var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 375,
    viewBox: "0 0 442 375",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1011_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480 317.189H-20V317.432H480V317.189Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.9 332.827H396.78V333.069H429.9V332.827Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.22 335.47H302.53V335.712H311.22V335.47Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.78 323.808H376.59V324.05H395.78V323.808Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.65 325.44H32.46V325.683H75.65V325.44Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8896 325.44H84.5596V325.683H90.8896V325.44Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.15 329.542H111.47V329.784H205.15V329.542Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 273.844H23.91C22.3973 273.841 20.9475 273.256 19.8788 272.215C18.8102 271.175 18.21 269.765 18.21 268.295V4.50077C18.2231 3.0391 18.8292 1.64151 19.8964 0.611568C20.9637 -0.418378 22.4059 -0.997496 23.91 -1H217C218.514 -1 219.967 -0.415337 221.038 0.62537C222.108 1.66608 222.71 3.07758 222.71 4.54936V268.295C222.71 269.766 222.108 271.178 221.038 272.219C219.967 273.259 218.514 273.844 217 273.844V273.844ZM23.91 -0.805626C22.4636 -0.803051 21.0774 -0.242852 20.0556 0.752011C19.0338 1.74687 18.46 3.09511 18.46 4.50077V268.295C18.46 269.7 19.0338 271.049 20.0556 272.043C21.0774 273.038 22.4636 273.598 23.91 273.601H217C218.447 273.598 219.834 273.039 220.858 272.044C221.881 271.049 222.457 269.701 222.46 268.295V4.50077C222.457 3.09421 221.881 1.746 220.858 0.751417C219.834 -0.243168 218.447 -0.803057 217 -0.805626H23.91Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.31 273.844H240.21C238.696 273.841 237.246 273.256 236.175 272.216C235.105 271.176 234.503 269.766 234.5 268.295V4.50077C234.516 3.03822 235.124 1.64064 236.193 0.61096C237.262 -0.418718 238.705 -0.997523 240.21 -1H433.31C434.812 -0.994942 436.252 -0.414694 437.317 0.614978C438.382 1.64465 438.987 3.04078 439 4.50077V268.295C439 269.763 438.401 271.172 437.335 272.212C436.268 273.252 434.821 273.839 433.31 273.844V273.844ZM240.21 -0.805626C238.763 -0.803057 237.375 -0.243168 236.352 0.751417C235.329 1.746 234.753 3.09421 234.75 4.50077V268.295C234.753 269.701 235.329 271.049 236.352 272.044C237.375 273.039 238.763 273.598 240.21 273.601H433.31C434.757 273.598 436.145 273.039 437.168 272.044C438.191 271.049 438.767 269.701 438.77 268.295V4.50077C438.767 3.09421 438.191 1.746 437.168 0.751417C436.145 -0.243168 434.757 -0.803057 433.31 -0.805626H240.21Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.15 316.587H408.66L400.48 174.237H376.34L368.15 316.587Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.17 170.787H374.64V178.135H402.17V170.787Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.03 316.587H359.54L351.36 174.237H327.22L319.03 316.587Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.05 170.787H325.52V178.135H353.05V170.787Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.92 294.195H328.88V316.587H372.92V294.195Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.84 294.195H280.8V316.587H324.84V294.195Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.43 294.195H378.39V316.587H422.43V294.195Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.81 251.462V241.442L135.34 251.462V241.442L109.88 251.462V241.442L84.4096 251.462V241.442L53.6796 253.532H53.3696V183.567H37.5596V316.587H43.5296H53.3696H186.28V260.831V253.532V241.442L160.81 251.462Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.44 280.453H130.12V316.596H207.44V280.453Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.12 279.714H106.31C105.869 279.72 105.433 279.811 105.028 279.981C104.623 280.151 104.256 280.397 103.949 280.705C103.642 281.013 103.4 281.376 103.237 281.775C103.074 282.173 102.994 282.599 103 283.028V308.297C102.995 309.028 103.239 309.741 103.695 310.323C104.151 310.906 104.793 311.324 105.52 311.514V316.558H107.64V311.65H111.64V316.587H113.76V311.65H117.76V316.587H119.88V311.543C120.607 311.353 121.247 310.934 121.702 310.352C122.156 309.769 122.398 309.057 122.39 308.326V283.057C122.412 282.193 122.08 281.355 121.467 280.729C120.854 280.102 120.01 279.737 119.12 279.714V279.714Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4798 279.714H82.6698C82.2285 279.72 81.7928 279.811 81.3877 279.981C80.9825 280.151 80.6158 280.397 80.3084 280.705C80.001 281.013 79.7591 281.376 79.5963 281.775C79.4335 282.173 79.3531 282.599 79.3598 283.028V308.297C79.3506 309.029 79.5936 309.744 80.0502 310.327C80.5068 310.909 81.1508 311.327 81.8797 311.514V316.558H83.9998V311.65H87.9998V316.587H90.1098V311.65H94.1098V316.587H96.2198V311.543C96.947 311.353 97.589 310.935 98.0451 310.353C98.5011 309.77 98.7455 309.058 98.7397 308.326V283.057C98.7613 282.194 98.4304 281.358 97.8196 280.732C97.2087 280.106 96.3675 279.74 95.4798 279.714V279.714Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8298 279.714H58.9998C58.5586 279.72 58.1229 279.811 57.7178 279.981C57.3126 280.151 56.9459 280.397 56.6385 280.705C56.3311 281.013 56.0891 281.376 55.9264 281.775C55.7636 282.173 55.6832 282.599 55.6898 283.028V308.297C55.6841 309.028 55.9284 309.741 56.3845 310.323C56.8406 310.906 57.4826 311.324 58.2098 311.514V316.558H60.3198V311.65H64.3198V316.587H66.4298V311.65H70.4298V316.587H72.5398V311.543C73.2688 311.356 73.9128 310.939 74.3694 310.356C74.826 309.773 75.069 309.058 75.0598 308.326V283.057C75.0815 282.199 74.7548 281.368 74.1503 280.742C73.5458 280.116 72.7122 279.747 71.8298 279.714Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1101 149.358C56.9201 145.655 64.9801 144.119 66.5101 147.2C68.0401 150.281 65.0001 152.555 65.0001 152.555C65.0001 152.555 69.6001 154.402 65.7701 157.22C61.9401 160.038 60.3901 157.22 60.3901 157.22C60.3901 157.22 55.9801 161.205 54.8301 159.659C53.6801 158.114 56.0001 156.958 56.0001 156.958C56.0001 156.958 52.2901 157.191 52.8001 153.537C53.3101 149.882 57.1101 149.358 57.1101 149.358Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4396 166.589C45.3396 164.742 49.3796 163.974 50.1396 165.51C50.3353 165.977 50.3669 166.495 50.2295 166.981C50.0921 167.468 49.7934 167.897 49.3796 168.202C49.3796 168.202 51.6796 169.174 49.7596 170.535C47.8396 171.895 47.0696 170.535 47.0696 170.535C47.0696 170.535 44.8696 172.527 44.2896 171.759C43.7096 170.991 44.8696 170.389 44.8696 170.389C44.638 170.418 44.4026 170.392 44.1833 170.314C43.9641 170.236 43.7676 170.107 43.6105 169.939C43.4534 169.771 43.3403 169.569 43.281 169.349C43.2216 169.13 43.2177 168.9 43.2696 168.678C43.3582 168.152 43.6158 167.666 44.0056 167.291C44.3953 166.916 44.8973 166.67 45.4396 166.589Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8804 128.074C43.6004 122.767 55.1704 120.551 57.3804 124.973C59.5904 129.395 55.1704 132.7 55.1704 132.7C55.1704 132.7 61.7904 135.343 56.2804 139.406C50.7704 143.468 48.5604 139.406 48.5604 139.406C48.5604 139.406 42.2304 145.11 40.5604 142.904C38.8904 140.698 42.2204 139.017 42.2204 139.017C42.2204 139.017 36.8904 139.357 37.6204 134.158C38.3504 128.958 43.8804 128.074 43.8804 128.074Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 138.842C343.81 135.139 351.87 133.604 353.4 136.684C354.93 139.765 351.87 142.069 351.87 142.069C351.87 142.069 356.47 143.915 352.64 146.734C348.81 149.552 347.26 146.734 347.26 146.734C347.26 146.734 342.85 150.718 341.7 149.173C340.55 147.628 342.85 146.442 342.85 146.442C342.85 146.442 339.14 146.675 339.65 143.021C340.16 139.367 344 138.842 344 138.842Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.31 156.073C332.21 154.227 336.24 153.459 337.01 154.994C337.204 155.463 337.234 155.981 337.095 156.467C336.956 156.954 336.655 157.383 336.24 157.686C336.24 157.686 338.55 158.61 336.63 160.019C334.71 161.428 333.94 160.019 333.94 160.019C333.94 160.019 331.74 161.963 331.16 161.243C330.58 160.524 331.74 159.873 331.74 159.873C331.508 159.902 331.273 159.877 331.053 159.798C330.834 159.72 330.638 159.591 330.481 159.424C330.323 159.256 330.21 159.053 330.151 158.834C330.092 158.614 330.088 158.384 330.14 158.163C330.228 157.636 330.486 157.151 330.876 156.775C331.265 156.4 331.767 156.154 332.31 156.073V156.073Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.75 117.568C330.47 112.252 342.04 110.045 344.25 114.467C346.46 118.889 342.04 122.194 342.04 122.194C342.04 122.194 348.66 124.837 343.15 128.9C337.64 132.962 335.43 128.9 335.43 128.9C335.43 128.9 329.1 134.605 327.43 132.398C325.76 130.192 329.09 128.511 329.09 128.511C329.09 128.511 323.76 128.851 324.49 123.652C325.22 118.452 330.75 117.568 330.75 117.568Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.46 141.738C397.27 138.035 405.33 136.5 406.87 139.571C408.41 142.642 405.33 144.955 405.33 144.955C405.33 144.955 409.94 146.802 406.1 149.63C402.26 152.458 400.72 149.63 400.72 149.63C400.72 149.63 396.31 153.605 395.16 152.069C394.01 150.533 396.31 149.338 396.31 149.338C396.31 149.338 392.6 149.571 393.11 145.917C393.62 142.263 397.46 141.738 397.46 141.738Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.79 158.969C385.7 157.123 389.73 156.345 390.5 157.891C390.693 158.359 390.722 158.877 390.583 159.363C390.444 159.849 390.144 160.278 389.73 160.583C389.73 160.583 392.03 161.555 390.11 162.915C388.19 164.276 387.42 162.915 387.42 162.915C387.42 162.915 385.22 164.907 384.64 164.14C384.06 163.372 385.22 162.769 385.22 162.769C384.989 162.799 384.753 162.773 384.534 162.695C384.315 162.616 384.118 162.488 383.961 162.32C383.804 162.152 383.691 161.949 383.632 161.73C383.572 161.51 383.568 161.28 383.62 161.059C383.709 160.533 383.966 160.047 384.356 159.672C384.746 159.296 385.248 159.051 385.79 158.969V158.969Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.23 120.483C383.96 115.167 395.53 112.961 397.73 117.373C399.93 121.786 395.53 125.1 395.53 125.1C395.53 125.1 402.14 127.753 396.63 131.806C391.12 135.858 388.91 131.806 388.91 131.806C388.91 131.806 382.58 137.52 380.91 135.314C379.24 133.108 382.56 131.427 382.56 131.427C382.56 131.427 377.23 131.767 377.97 126.519C378.71 121.271 384.23 120.483 384.23 120.483Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.9 267.469V244.066H313.77V162.701H304.91V152.195L285.99 143.361V132.777H283.37V162.701H279.7V244.066H276.04V201.284H266.08V179.233H263.3V244.066H255.74V219.39H250.76V213.093H239.23V191.575H232.91V176.346H225.15V154.168H222.38V176.346H214.62V191.575H208.31V213.093H196.78V219.39H191.8V244.066H185.89V213.093H174.36V146.422H170.69V139.075H146.06V146.422H140.82V194.724H119.85V199.448H111.99V203.121H119.85V222.024H107.09V222.141H86.8604V316.587H324.09V267.469H319.9Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3801 226.806H91.4102V229.78H94.3801V226.806Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3801 231.791H91.4102V234.765H94.3801V231.791Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 149.017H144.51V151.991H147.48V149.017Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 154.003H144.51V156.977H147.48V154.003Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 158.989H144.51V161.963H147.48V158.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 163.984H144.51V166.958H147.48V163.984Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 168.97H144.51V171.944H147.48V168.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 173.956H144.51V176.929H147.48V173.956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 178.941H144.51V181.915H147.48V178.941Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 183.927H144.51V186.901H147.48V183.927Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 198.894H144.51V201.867H147.48V198.894Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.48 203.879H144.51V206.853H147.48V203.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 149.017H149.23V151.991H152.2V149.017Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 154.003H149.23V156.977H152.2V154.003Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 158.989H149.23V161.963H152.2V158.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 163.984H149.23V166.958H152.2V163.984Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 168.97H149.23V171.944H152.2V168.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 173.956H149.23V176.929H152.2V173.956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 178.941H149.23V181.915H152.2V178.941Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 183.927H149.23V186.901H152.2V183.927Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.2 203.879H149.23V206.853H152.2V203.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92 149.017H153.95V151.991H156.92V149.017Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92 154.003H153.95V156.977H156.92V154.003Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92 158.989H153.95V161.963H156.92V158.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92 163.984H153.95V166.958H156.92V163.984Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92 168.97H153.95V171.944H156.92V168.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92 173.956H153.95V176.929H156.92V173.956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92 178.941H153.95V181.915H156.92V178.941Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.92 183.927H153.95V186.901H156.92V183.927Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 149.017H158.67V151.991H161.64V149.017Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 154.003H158.67V156.977H161.64V154.003Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 158.989H158.67V161.963H161.64V158.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 163.984H158.67V166.958H161.64V163.984Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 168.97H158.67V171.944H161.64V168.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 173.956H158.67V176.929H161.64V173.956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 183.927H158.67V186.901H161.64V183.927Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 188.913H158.67V191.887H161.64V188.913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 203.879H158.67V206.853H161.64V203.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 208.865H158.67V211.839H161.64V208.865Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 213.851H158.67V216.824H161.64V213.851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 218.836H158.67V221.81H161.64V218.836Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 223.822H158.67V226.796H161.64V223.822Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 228.817H158.67V231.791H161.64V228.817Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.64 233.803H158.67V236.777H161.64V233.803Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 149.017H163.38V151.991H166.35V149.017Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 154.003H163.38V156.977H166.35V154.003Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 158.989H163.38V161.963H166.35V158.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 163.984H163.38V166.958H166.35V163.984Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 168.97H163.38V171.944H166.35V168.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 173.956H163.38V176.929H166.35V173.956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 188.913H163.38V191.887H166.35V188.913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 193.908H163.38V196.882H166.35V193.908Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 198.894H163.38V201.867H166.35V198.894Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 203.879H163.38V206.853H166.35V203.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 208.865H163.38V211.839H166.35V208.865Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 213.851H163.38V216.824H166.35V213.851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 218.836H163.38V221.81H166.35V218.836Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 223.822H163.38V226.796H166.35V223.822Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 228.817H163.38V231.791H166.35V228.817Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 233.803H163.38V236.777H166.35V233.803Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 238.789H163.38V241.763H166.35V238.789Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.35 248.76H163.38V251.734H166.35V248.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 149.017H168.1V151.991H171.07V149.017Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 154.003H168.1V156.977H171.07V154.003Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 158.989H168.1V161.963H171.07V158.989Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 163.984H168.1V166.958H171.07V163.984Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 168.97H168.1V171.944H171.07V168.97Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 173.956H168.1V176.929H171.07V173.956Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 188.913H168.1V191.887H171.07V188.913Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 193.908H168.1V196.882H171.07V193.908Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 198.894H168.1V201.867H171.07V198.894Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 203.879H168.1V206.853H171.07V203.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 218.836H168.1V221.81H171.07V218.836Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 223.822H168.1V226.796H171.07V223.822Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 228.817H168.1V231.791H171.07V228.817Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 233.803H168.1V236.777H171.07V233.803Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 238.789H168.1V241.763H171.07V238.789Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 248.76H168.1V251.734H171.07V248.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07 253.746H168.1V256.72H171.07V253.746Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 195.395H210.9V198.369H213.87V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 200.381H210.9V203.355H213.87V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 205.366H210.9V208.34H213.87V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 210.352H210.9V213.326H213.87V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 215.338H210.9V218.312H213.87V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 220.323H210.9V223.297H213.87V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 225.319H210.9V228.293H213.87V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 240.276H210.9V243.25H213.87V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 245.261H210.9V248.235H213.87V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.87 250.247H210.9V253.221H213.87V250.247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.59 195.395H215.62V198.369H218.59V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.59 200.381H215.62V203.355H218.59V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.59 205.366H215.62V208.34H218.59V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.59 210.352H215.62V213.326H218.59V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.59 215.338H215.62V218.312H218.59V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.59 220.323H215.62V223.297H218.59V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.59 225.319H215.62V228.293H218.59V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3 195.395H220.33V198.369H223.3V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3 200.381H220.33V203.355H223.3V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3 205.366H220.33V208.34H223.3V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3 210.352H220.33V213.326H223.3V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3 215.338H220.33V218.312H223.3V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3 220.323H220.33V223.297H223.3V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3 225.319H220.33V228.293H223.3V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 195.395H225.05V198.369H228.02V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 200.381H225.05V203.355H228.02V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 205.366H225.05V208.34H228.02V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 210.352H225.05V213.326H228.02V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 215.338H225.05V218.312H228.02V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 220.323H225.05V223.297H228.02V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 225.319H225.05V228.293H228.02V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 230.304H225.05V233.278H228.02V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 235.29H225.05V238.264H228.02V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 240.276H225.05V243.25H228.02V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.02 245.261H225.05V248.235H228.02V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 195.395H229.77V198.369H232.74V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 200.381H229.77V203.355H232.74V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 205.366H229.77V208.34H232.74V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 210.352H229.77V213.326H232.74V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 215.338H229.77V218.312H232.74V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 220.323H229.77V223.297H232.74V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 225.319H229.77V228.293H232.74V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 230.304H229.77V233.278H232.74V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 235.29H229.77V238.264H232.74V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 240.276H229.77V243.25H232.74V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 245.261H229.77V248.235H232.74V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 250.247H229.77V253.221H232.74V250.247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 265.214H229.77V268.188H232.74V265.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.74 270.199H229.77V273.173H232.74V270.199Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 195.395H234.49V198.369H237.46V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 200.381H234.49V203.355H237.46V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 205.366H234.49V208.34H237.46V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 220.323H234.49V223.297H237.46V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 225.319H234.49V228.293H237.46V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 230.304H234.49V233.278H237.46V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 235.29H234.49V238.264H237.46V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 240.276H234.49V243.25H237.46V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 245.261H234.49V248.235H237.46V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 250.247H234.49V253.221H237.46V250.247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 265.214H234.49V268.188H237.46V265.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 270.199H234.49V273.173H237.46V270.199Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.46 275.185H234.49V278.159H237.46V275.185Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 165.471H283.92V168.445H286.89V165.471Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 170.457H283.92V173.431H286.89V170.457Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 175.443H283.92V178.416H286.89V175.443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 180.428H283.92V183.402H286.89V180.428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 185.414H283.92V188.388H286.89V185.414Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 190.4H283.92V193.373H286.89V190.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 195.395H283.92V198.369H286.89V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 200.381H283.92V203.355H286.89V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 205.366H283.92V208.34H286.89V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 210.352H283.92V213.326H286.89V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 215.338H283.92V218.312H286.89V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 220.323H283.92V223.297H286.89V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 225.319H283.92V228.293H286.89V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 230.304H283.92V233.278H286.89V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 235.29H283.92V238.264H286.89V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 240.276H283.92V243.25H286.89V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 245.261H283.92V248.235H286.89V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 250.247H283.92V253.221H286.89V250.247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 255.242H283.92V258.216H286.89V255.242Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 260.228H283.92V263.202H286.89V260.228Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 265.214H283.92V268.188H286.89V265.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 270.199H283.92V273.173H286.89V270.199Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.89 275.185H283.92V278.159H286.89V275.185Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 165.471H288.64V168.445H291.61V165.471Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 170.457H288.64V173.431H291.61V170.457Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 175.443H288.64V178.416H291.61V175.443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 180.428H288.64V183.402H291.61V180.428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 185.414H288.64V188.388H291.61V185.414Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 190.4H288.64V193.373H291.61V190.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 195.395H288.64V198.369H291.61V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 200.381H288.64V203.355H291.61V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 205.366H288.64V208.34H291.61V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 210.352H288.64V213.326H291.61V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 215.338H288.64V218.312H291.61V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 220.323H288.64V223.297H291.61V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 225.319H288.64V228.293H291.61V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 230.304H288.64V233.278H291.61V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 235.29H288.64V238.264H291.61V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 240.276H288.64V243.25H291.61V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 245.261H288.64V248.235H291.61V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 250.247H288.64V253.221H291.61V250.247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.61 255.242H288.64V258.216H291.61V255.242Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 165.471H293.36V168.445H296.33V165.471Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 170.457H293.36V173.431H296.33V170.457Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 175.443H293.36V178.416H296.33V175.443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 180.428H293.36V183.402H296.33V180.428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 185.414H293.36V188.388H296.33V185.414Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 190.4H293.36V193.373H296.33V190.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 195.395H293.36V198.369H296.33V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 200.381H293.36V203.355H296.33V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 205.366H293.36V208.34H296.33V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 210.352H293.36V213.326H296.33V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 215.338H293.36V218.312H296.33V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 220.323H293.36V223.297H296.33V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 225.319H293.36V228.293H296.33V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 230.304H293.36V233.278H296.33V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 235.29H293.36V238.264H296.33V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 240.276H293.36V243.25H296.33V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 245.261H293.36V248.235H296.33V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 250.247H293.36V253.221H296.33V250.247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33 255.242H293.36V258.216H296.33V255.242Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 165.471H298.08V168.445H301.05V165.471Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 170.457H298.08V173.431H301.05V170.457Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 175.443H298.08V178.416H301.05V175.443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 180.428H298.08V183.402H301.05V180.428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 185.414H298.08V188.388H301.05V185.414Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 190.4H298.08V193.373H301.05V190.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 195.395H298.08V198.369H301.05V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 200.381H298.08V203.355H301.05V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 205.366H298.08V208.34H301.05V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 210.352H298.08V213.326H301.05V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 215.338H298.08V218.312H301.05V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 220.323H298.08V223.297H301.05V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 225.319H298.08V228.293H301.05V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 230.304H298.08V233.278H301.05V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.05 235.29H298.08V238.264H301.05V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 165.471H302.79V168.445H305.76V165.471Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 170.457H302.79V173.431H305.76V170.457Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 175.443H302.79V178.416H305.76V175.443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 180.428H302.79V183.402H305.76V180.428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 185.414H302.79V188.388H305.76V185.414Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 190.4H302.79V193.373H305.76V190.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 195.395H302.79V198.369H305.76V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 200.381H302.79V203.355H305.76V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 205.366H302.79V208.34H305.76V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 210.352H302.79V213.326H305.76V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 215.338H302.79V218.312H305.76V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 220.323H302.79V223.297H305.76V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76 225.319H302.79V228.293H305.76V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 165.471H307.51V168.445H310.48V165.471Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 170.457H307.51V173.431H310.48V170.457Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 175.443H307.51V178.416H310.48V175.443Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 180.428H307.51V183.402H310.48V180.428Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 185.414H307.51V188.388H310.48V185.414Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 190.4H307.51V193.373H310.48V190.4Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 195.395H307.51V198.369H310.48V195.395Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 200.381H307.51V203.355H310.48V200.381Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 205.366H307.51V208.34H310.48V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 210.352H307.51V213.326H310.48V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 215.338H307.51V218.312H310.48V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48 220.323H307.51V223.297H310.48V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 198.894H123.9V201.867H126.87V198.894Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 203.879H123.9V206.853H126.87V203.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 208.865H123.9V211.839H126.87V208.865Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 213.851H123.9V216.824H126.87V213.851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 218.836H123.9V221.81H126.87V218.836Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 223.822H123.9V226.796H126.87V223.822Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 228.817H123.9V231.791H126.87V228.817Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 233.803H123.9V236.777H126.87V233.803Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 238.789H123.9V241.763H126.87V238.789Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 243.774H123.9V246.748H126.87V243.774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 248.76H123.9V251.734H126.87V248.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 253.746H123.9V256.72H126.87V253.746Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 258.741H123.9V261.715H126.87V258.741Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 268.713H123.9V271.686H126.87V268.713Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 273.698H123.9V276.672H126.87V273.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 278.684H123.9V281.658H126.87V278.684Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 283.67H123.9V286.643H126.87V283.67Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 293.651H123.9V296.625H126.87V293.651Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 298.636H123.9V301.61H126.87V298.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87 303.622H123.9V306.596H126.87V303.622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 198.894H128.62V201.867H131.59V198.894Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 203.879H128.62V206.853H131.59V203.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 208.865H128.62V211.839H131.59V208.865Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 213.851H128.62V216.824H131.59V213.851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 218.836H128.62V221.81H131.59V218.836Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 223.822H128.62V226.796H131.59V223.822Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 228.817H128.62V231.791H131.59V228.817Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 233.803H128.62V236.777H131.59V233.803Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 238.789H128.62V241.763H131.59V238.789Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 243.774H128.62V246.748H131.59V243.774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 248.76H128.62V251.734H131.59V248.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 253.746H128.62V256.72H131.59V253.746Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 258.741H128.62V261.715H131.59V258.741Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 273.698H128.62V276.672H131.59V273.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 278.684H128.62V281.658H131.59V278.684Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 288.665H128.62V291.639H131.59V288.665Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 293.651H128.62V296.625H131.59V293.651Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 298.636H128.62V301.61H131.59V298.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59 303.622H128.62V306.596H131.59V303.622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 198.894H133.33V201.867H136.3V198.894Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 203.879H133.33V206.853H136.3V203.879Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 208.865H133.33V211.839H136.3V208.865Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 213.851H133.33V216.824H136.3V213.851Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 218.836H133.33V221.81H136.3V218.836Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 223.822H133.33V226.796H136.3V223.822Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 228.817H133.33V231.791H136.3V228.817Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 233.803H133.33V236.777H136.3V233.803Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 238.789H133.33V241.763H136.3V238.789Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 243.774H133.33V246.748H136.3V243.774Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 248.76H133.33V251.734H136.3V248.76Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 253.746H133.33V256.72H136.3V253.746Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 258.741H133.33V261.715H136.3V258.741Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 263.727H133.33V266.701H136.3V263.727Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 273.698H133.33V276.672H136.3V273.698Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 283.67H133.33V286.643H136.3V283.67Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 288.665H133.33V291.639H136.3V288.665Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 293.651H133.33V296.625H136.3V293.651Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 298.636H133.33V301.61H136.3V298.636Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3 303.622H133.33V306.596H136.3V303.622Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 227.33H104.68V230.304H107.65V227.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 232.316H104.68V235.29H107.65V232.316Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 237.302H104.68V240.276H107.65V237.302Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 242.287H104.68V245.261H107.65V242.287Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 247.273H104.68V250.247H107.65V247.273Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 252.259H104.68V255.233H107.65V252.259Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 267.226H104.68V270.199H107.65V267.226Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 272.211H104.68V275.185H107.65V272.211Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 277.197H104.68V280.171H107.65V277.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 282.183H104.68V285.157H107.65V282.183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 287.178H104.68V290.152H107.65V287.178Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 292.164H104.68V295.138H107.65V292.164Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.65 297.149H104.68V300.123H107.65V297.149Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 227.33H109.4V230.304H112.37V227.33Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 232.316H109.4V235.29H112.37V232.316Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 237.302H109.4V240.276H112.37V237.302Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 242.287H109.4V245.261H112.37V242.287Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 247.273H109.4V250.247H112.37V247.273Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 252.259H109.4V255.233H112.37V252.259Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 267.226H109.4V270.199H112.37V267.226Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 272.211H109.4V275.185H112.37V272.211Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 277.197H109.4V280.171H112.37V277.197Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 282.183H109.4V285.157H112.37V282.183Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 287.178H109.4V290.152H112.37V287.178Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 292.164H109.4V295.138H112.37V292.164Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.37 302.135H109.4V305.109H112.37V302.135Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 205.366H266.11V208.34H269.08V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 210.352H266.11V213.326H269.08V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 215.338H266.11V218.312H269.08V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 220.323H266.11V223.297H269.08V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 225.319H266.11V228.293H269.08V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 230.304H266.11V233.278H269.08V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 235.29H266.11V238.264H269.08V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 240.276H266.11V243.25H269.08V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 245.261H266.11V248.235H269.08V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 250.247H266.11V253.221H269.08V250.247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 255.242H266.11V258.216H269.08V255.242Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 265.214H266.11V268.188H269.08V265.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 270.199H266.11V273.173H269.08V270.199Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 275.185H266.11V278.159H269.08V275.185Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 280.171H266.11V283.145H269.08V280.171Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 285.166H266.11V288.14H269.08V285.166Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 290.152H266.11V293.126H269.08V290.152Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 295.138H266.11V298.111H269.08V295.138Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.08 300.123H266.11V303.097H269.08V300.123Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 205.366H270.82V208.34H273.79V205.366Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 210.352H270.82V213.326H273.79V210.352Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 215.338H270.82V218.312H273.79V215.338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 220.323H270.82V223.297H273.79V220.323Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 225.319H270.82V228.293H273.79V225.319Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 230.304H270.82V233.278H273.79V230.304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 235.29H270.82V238.264H273.79V235.29Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 240.276H270.82V243.25H273.79V240.276Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 245.261H270.82V248.235H273.79V245.261Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 250.247H270.82V253.221H273.79V250.247Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 255.242H270.82V258.216H273.79V255.242Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 260.228H270.82V263.202H273.79V260.228Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 265.214H270.82V268.188H273.79V265.214Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 270.199H270.82V273.173H273.79V270.199Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 275.185H270.82V278.159H273.79V275.185Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 280.171H270.82V283.145H273.79V280.171Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 285.166H270.82V288.14H273.79V285.166Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 290.152H270.82V293.126H273.79V290.152Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 295.138H270.82V298.111H273.79V295.138Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.79 300.123H270.82V303.097H273.79V300.123Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 224.794H242.87V227.768H245.84V224.794Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 229.78H242.87V232.753H245.84V229.78Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 234.765H242.87V237.739H245.84V234.765Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 239.751H242.87V242.725H245.84V239.751Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 244.737H242.87V247.71H245.84V244.737Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 249.722H242.87V252.696H245.84V249.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 254.718H242.87V257.692H245.84V254.718Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 259.703H242.87V262.677H245.84V259.703Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 264.689H242.87V267.663H245.84V264.689Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.84 269.675H242.87V272.649H245.84V269.675Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 224.794H247.59V227.768H250.56V224.794Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 229.78H247.59V232.753H250.56V229.78Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 234.765H247.59V237.739H250.56V234.765Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 239.751H247.59V242.725H250.56V239.751Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 244.737H247.59V247.71H250.56V244.737Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 249.722H247.59V252.696H250.56V249.722Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 254.718H247.59V257.692H250.56V254.718Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 259.703H247.59V262.677H250.56V259.703Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.56 264.689H247.59V267.663H250.56V264.689Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.22 43.8711C104.209 43.1636 104.34 42.4609 104.609 41.8032C104.877 41.1454 105.276 40.5456 105.783 40.0382C106.291 39.5307 106.896 39.1256 107.565 38.846C108.234 38.5665 108.953 38.418 109.68 38.4092C110.209 38.4084 110.735 38.4837 111.24 38.6327C111.16 38.0789 111.12 37.5203 111.12 36.9611C111.075 33.9366 112.267 31.0184 114.435 28.8479C116.603 26.6773 119.568 25.4322 122.68 25.3862C123.395 25.3864 124.108 25.4514 124.81 25.5805C125.685 24.1088 126.941 22.8857 128.453 22.033C129.966 21.1804 131.682 20.728 133.43 20.7212C136.126 20.7595 138.697 21.8269 140.589 23.6928C142.48 25.5586 143.541 28.073 143.54 30.6925H143.71C146.202 30.7707 148.564 31.7874 150.298 33.5277C152.031 35.2679 153.001 37.5953 153.001 40.0176C153.001 42.4399 152.031 44.7673 150.298 46.5075C148.564 48.2478 146.202 49.2645 143.71 49.3427H109.52C108.078 49.2796 106.718 48.673 105.729 47.6515C104.739 46.6299 104.198 45.2739 104.22 43.8711Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.1 97.3918C208.078 95.9629 208.641 94.5841 209.665 93.5582C210.689 92.5324 212.089 91.9432 213.56 91.9202C214.092 91.9234 214.621 92.002 215.13 92.1535C215.045 91.5967 215.002 91.0348 215 90.4721C214.954 87.4476 216.146 84.5294 218.314 82.3589C220.482 80.1884 223.448 78.9432 226.56 78.8972C227.275 78.8958 227.988 78.9642 228.69 79.1013C229.565 77.6282 230.822 76.4041 232.337 75.5513C233.851 74.6986 235.569 74.2471 237.32 74.2419C240.015 74.2828 242.585 75.3527 244.475 77.2204C246.365 79.088 247.423 81.6035 247.42 84.223H247.59C250.081 84.3012 252.443 85.3179 254.177 87.0582C255.91 88.7984 256.88 91.1258 256.88 93.5481C256.88 95.9704 255.91 98.2978 254.177 100.038C252.443 101.778 250.081 102.795 247.59 102.873H213.41C211.963 102.815 210.597 102.209 209.605 101.184C208.613 100.16 208.072 98.7986 208.1 97.3918V97.3918Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.47 146.724C107.449 145.295 108.012 143.916 109.036 142.89C110.059 141.864 111.46 141.275 112.93 141.252C113.463 141.255 113.992 141.333 114.5 141.485C114.42 140.928 114.38 140.367 114.38 139.804C114.34 136.785 115.534 133.875 117.699 131.71C119.864 129.546 122.825 128.304 125.93 128.258C126.646 128.257 127.359 128.325 128.06 128.462C128.935 126.989 130.193 125.765 131.708 124.912C133.222 124.06 134.94 123.608 136.69 123.603C139.385 123.644 141.956 124.714 143.846 126.581C145.736 128.449 146.793 130.965 146.79 133.584H147C149.492 133.662 151.854 134.679 153.587 136.419C155.321 138.159 156.291 140.487 156.291 142.909C156.291 145.331 155.321 147.659 153.587 149.399C151.854 151.139 149.492 152.156 147 152.234H112.78C111.329 152.176 109.958 151.566 108.965 150.535C107.972 149.504 107.435 148.136 107.47 146.724V146.724Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.4 80.0926C363.389 79.2298 363.73 78.398 364.348 77.7788C364.967 77.1597 365.812 76.8036 366.7 76.7882C367.022 76.7916 367.342 76.8407 367.65 76.934C367.601 76.5959 367.577 76.2549 367.58 75.9135C367.565 75.007 367.735 74.1066 368.079 73.2639C368.423 72.4213 368.935 71.6529 369.585 71.0028C370.236 70.3528 371.012 69.8339 371.869 69.4758C372.726 69.1177 373.647 68.9275 374.58 68.9161C375.013 68.9186 375.445 68.9609 375.87 69.0424C376.402 68.158 377.163 67.4238 378.076 66.9125C378.99 66.4011 380.025 66.1303 381.08 66.1268C382.71 66.1498 384.266 66.7961 385.409 67.9258C386.553 69.0554 387.193 70.5774 387.19 72.1621H387.29C388.828 72.1621 390.303 72.756 391.391 73.8131C392.479 74.8702 393.09 76.304 393.09 77.799C393.09 79.2939 392.479 80.7277 391.391 81.7848C390.303 82.8419 388.828 83.4358 387.29 83.4358H366.61C365.73 83.4004 364.9 83.0297 364.299 82.404C363.698 81.7784 363.375 80.948 363.4 80.0926V80.0926Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1796 84.155C49.173 83.7274 49.2531 83.3028 49.4154 82.9053C49.5777 82.5078 49.8189 82.1453 50.1254 81.8384C50.4318 81.5316 50.7974 81.2864 51.2014 81.1169C51.6053 80.9474 52.0397 80.8569 52.4796 80.8506C52.8182 80.846 53.1554 80.8919 53.4796 80.9867C53.4297 80.6649 53.4029 80.3402 53.3996 80.0148C53.3864 79.1086 53.557 78.2088 53.9016 77.3667C54.2463 76.5246 54.7582 75.7567 55.4083 75.1069C56.0583 74.4571 56.8337 73.9382 57.6901 73.5796C58.5465 73.2211 59.4672 73.03 60.3996 73.0174C60.8325 73.0167 61.2644 73.0558 61.6896 73.134C62.222 72.2495 62.9827 71.5153 63.8964 71.004C64.8101 70.4927 65.8453 70.2219 66.8996 70.2184C68.5283 70.2414 70.0823 70.8863 71.2256 72.0139C72.369 73.1414 73.0098 74.6609 73.0096 76.244H73.1096C74.6479 76.244 76.1231 76.8378 77.2109 77.895C78.2986 78.9521 78.9096 80.3858 78.9096 81.8808C78.9096 83.3758 78.2986 84.8095 77.2109 85.8666C76.1231 86.9237 74.6479 87.5176 73.1096 87.5176H52.3896C51.5063 87.4822 50.6732 87.1089 50.0719 86.479C49.4706 85.8491 49.1499 85.0137 49.1796 84.155V84.155Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.19 44.979C300.183 44.5515 300.264 44.1268 300.426 43.7293C300.588 43.3319 300.829 42.9694 301.136 42.6625C301.442 42.3557 301.808 42.1105 302.212 41.941C302.616 41.7715 303.05 41.681 303.49 41.6747C303.813 41.6733 304.134 41.7225 304.44 41.8205C304.394 41.4985 304.37 41.1737 304.37 40.8486C304.355 39.9421 304.525 39.0417 304.869 38.199C305.214 37.3563 305.725 36.5879 306.376 35.9379C307.026 35.2879 307.802 34.7689 308.659 34.4108C309.516 34.0527 310.437 33.8625 311.37 33.8512C311.803 33.8537 312.235 33.896 312.66 33.9775C313.192 33.093 313.953 32.3588 314.867 31.8475C315.781 31.3362 316.816 31.0654 317.87 31.0619C319.49 31.0796 321.039 31.7129 322.184 32.8264C323.33 33.9398 323.982 35.4449 324 37.0194H324.1C325.638 37.0194 327.114 37.6133 328.201 38.6704C329.289 39.7275 329.9 41.1613 329.9 42.6563C329.9 44.1512 329.289 45.585 328.201 46.6421C327.114 47.6992 325.638 48.2931 324.1 48.2931H303.4C302.526 48.2577 301.7 47.8911 301.1 47.2718C300.5 46.6524 300.174 45.8295 300.19 44.979V44.979Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230 365.938C337.083 365.938 423.89 361.013 423.89 354.937C423.89 348.861 337.083 343.935 230 343.935C122.918 343.935 36.1104 348.861 36.1104 354.937C36.1104 361.013 122.918 365.938 230 365.938Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6895 285.847C70.8995 287.275 66.9095 288.208 63.6895 288.762C63.9495 291.357 65.6895 293.971 68.1795 296.42C71.2695 294.729 75.6695 292.533 76.4795 293.048C77.2895 293.563 72.8595 296.479 70.0395 298.141C72.0553 299.85 74.1904 301.422 76.4295 302.844C77.8095 301.591 79.4295 300.493 80.4295 301.085C81.4295 301.678 81.1595 303.641 80.6595 305.381C84.0195 307.325 86.5294 308.442 86.5294 308.442C87.5058 305.412 88.2544 302.316 88.7694 299.181C88.6094 298.85 88.4394 298.52 88.2794 298.209C87.7394 296.994 88.2795 296.469 89.1595 296.265C89.414 294.047 89.4341 291.81 89.2195 289.588C85.4195 288.82 80.7994 287.382 82.5294 285.166C83.5294 283.835 85.5295 283.679 87.4695 284.019C87.1962 283.577 86.8815 283.161 86.5294 282.775C79.6194 275.37 74.7995 282.775 74.7995 282.775C70.7995 279.52 65.1295 280.404 63.9095 285.487C66.1095 284.914 70.4295 284.078 70.6895 285.847Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70.6895 285.847C70.8995 287.275 66.9095 288.208 63.6895 288.762C63.9495 291.357 65.6895 293.971 68.1795 296.42C71.2695 294.729 75.6695 292.533 76.4795 293.048C77.2895 293.563 72.8595 296.479 70.0395 298.141C72.0553 299.85 74.1904 301.422 76.4295 302.844C77.8095 301.591 79.4295 300.493 80.4295 301.085C81.4295 301.678 81.1595 303.641 80.6595 305.381C84.0195 307.325 86.5294 308.442 86.5294 308.442C87.5058 305.412 88.2544 302.316 88.7694 299.181C88.6094 298.85 88.4394 298.52 88.2794 298.209C87.7394 296.994 88.2795 296.469 89.1595 296.265C89.414 294.047 89.4341 291.81 89.2195 289.588C85.4195 288.82 80.7994 287.382 82.5294 285.166C83.5294 283.835 85.5295 283.679 87.4695 284.019C87.1962 283.577 86.8815 283.161 86.5294 282.775C79.6194 275.37 74.7995 282.775 74.7995 282.775C70.7995 279.52 65.1295 280.404 63.9095 285.487C66.1095 284.914 70.4295 284.078 70.6895 285.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3096 340.252L78.3096 340.174C78.3096 339.678 82.3996 290.103 70.9496 285.429C70.4047 285.179 69.8075 285.056 69.2052 285.069C68.6029 285.083 68.0121 285.232 67.4796 285.506C63.3596 287.644 61.3696 296.284 61.3496 296.391L60.3496 296.177C60.4296 295.808 62.4496 286.974 66.9996 284.671C67.6624 284.331 68.3966 284.144 69.1456 284.123C69.8947 284.103 70.6385 284.25 71.3196 284.554C83.4596 289.472 79.4896 338.182 79.3096 340.252Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7601 339.153C80.5501 336.918 75.8801 284.466 84.6201 278.898C86.7101 277.566 88.6201 277.275 90.1701 278.062C94.3001 280.083 94.8401 288.665 94.8601 289.025L93.8601 289.083C93.8601 288.995 93.3301 280.696 89.7201 278.927C88.4701 278.315 86.9401 278.577 85.1701 279.714C76.9301 284.962 81.7001 338.522 81.7501 339.066L80.7601 339.153Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0703 343.42C82.0103 341.71 80.5703 301.562 88.5203 298.044C89.2625 297.707 90.0714 297.533 90.8903 297.533C91.7091 297.533 92.5181 297.707 93.2603 298.044C98.7203 300.376 102.09 310.26 102.26 310.678L101.26 310.979C101.26 310.882 97.8803 301.085 92.8303 298.928C92.2197 298.645 91.5518 298.498 90.8753 298.498C90.1988 298.498 89.5308 298.645 88.9203 298.928C82.8203 301.63 82.6103 331.971 83.0503 343.381L82.0703 343.42Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0498 341.583L79.0498 341.476C80.4498 329.522 83.1398 297.684 78.7598 293.855C78.5461 293.605 78.2623 293.42 77.9428 293.323C77.6233 293.227 77.2819 293.222 76.9598 293.31C73.9998 294.448 72.2398 304.798 71.7998 308.695L70.7998 308.588C70.9698 307.092 72.5698 293.942 76.5998 292.436C77.0895 292.278 77.6159 292.262 78.1148 292.39C78.6137 292.517 79.0636 292.783 79.4098 293.155C85.0798 298.063 80.2498 339.805 80.0498 341.583Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3604 318.929H99.2803L96.2803 358.037H66.3604L63.3604 318.929Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.2695 318.929L75.2695 358.037H96.2795L99.2795 318.929H74.2695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2502 304.574C67.8802 305.546 65.0902 304.779 62.9002 304.02C62.1402 305.712 62.3202 307.908 62.9602 310.25C65.4602 310.25 68.9602 310.318 69.2802 310.93C69.6002 311.543 65.8302 311.834 63.5002 311.902C64.1413 313.629 64.9031 315.311 65.7802 316.937C67.0802 316.626 68.4702 316.48 68.8502 317.17C69.2302 317.86 68.4002 318.997 67.4802 319.901C68.8802 322.185 70.0202 323.788 70.0202 323.788C71.6937 322.246 73.2479 320.586 74.6702 318.822C74.6702 318.569 74.6702 318.307 74.6702 318.044C74.7702 317.073 75.2802 316.966 75.8902 317.16C76.8258 315.879 77.6233 314.508 78.2702 313.069C76.2002 311.319 73.8602 308.899 75.7102 308.112C76.8202 307.636 78.0602 308.18 79.1602 309.084C79.1543 308.72 79.1073 308.359 79.0202 308.005C77.3702 301.134 71.7802 304.118 71.7802 304.118C70.4502 300.765 66.6602 299.433 64.1202 302.174C65.7602 302.475 68.7102 303.398 68.2502 304.574Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.2502 304.574C67.8802 305.546 65.0902 304.779 62.9002 304.02C62.1402 305.712 62.3202 307.908 62.9602 310.25C65.4602 310.25 68.9602 310.318 69.2802 310.93C69.6002 311.543 65.8302 311.834 63.5002 311.902C64.1413 313.629 64.9031 315.311 65.7802 316.937C67.0802 316.626 68.4702 316.48 68.8502 317.17C69.2302 317.86 68.4002 318.997 67.4802 319.901C68.8802 322.185 70.0202 323.788 70.0202 323.788C71.6937 322.246 73.2479 320.586 74.6702 318.822C74.6702 318.569 74.6702 318.307 74.6702 318.044C74.7702 317.073 75.2802 316.966 75.8902 317.16C76.8258 315.879 77.6233 314.508 78.2702 313.069C76.2002 311.319 73.8602 308.899 75.7102 308.112C76.8202 307.636 78.0602 308.18 79.1602 309.084C79.1543 308.72 79.1073 308.359 79.0202 308.005C77.3702 301.134 71.7802 304.118 71.7802 304.118C70.4502 300.765 66.6602 299.433 64.1202 302.174C65.7602 302.475 68.7102 303.398 68.2502 304.574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9297 309.22C93.8087 309.31 92.7035 309.535 91.6397 309.891C91.3585 309.148 91.1966 308.368 91.1597 307.577C90.9297 300.541 96.1597 303.505 98.8597 301.435C99.4819 300.904 100.212 300.506 101.003 300.266C101.793 300.027 102.627 299.952 103.45 300.046C103.209 300.43 103.002 300.833 102.83 301.251C102.766 301.404 102.739 301.57 102.75 301.736C102.761 301.901 102.81 302.062 102.893 302.206C102.977 302.351 103.092 302.476 103.232 302.571C103.372 302.666 103.531 302.73 103.7 302.757C104.375 302.877 105.073 302.796 105.7 302.524C105.883 302.418 106.057 302.298 106.22 302.164C106.655 302.907 106.991 303.701 107.22 304.526C107.494 305.509 107.648 306.52 107.68 307.539C107.27 307.626 106.866 307.737 106.47 307.869C106.313 307.935 106.173 308.035 106.062 308.162C105.95 308.288 105.87 308.437 105.826 308.598C105.783 308.759 105.778 308.928 105.811 309.091C105.845 309.254 105.916 309.408 106.02 309.541C106.454 309.96 106.958 310.305 107.51 310.561C107.328 311.691 107.023 312.799 106.6 313.865H106.23C105.966 313.917 105.706 313.981 105.45 314.06C105.303 314.098 105.159 314.147 105.02 314.206C104.842 314.281 104.686 314.399 104.567 314.549C104.449 314.698 104.37 314.874 104.34 315.061C104.311 315.253 104.336 315.449 104.412 315.628C104.487 315.807 104.611 315.964 104.77 316.081C104.94 316.203 105.121 316.31 105.31 316.402C104.615 317.564 103.628 318.534 102.44 319.22C101.389 318.754 100.367 318.229 99.3797 317.646C99.5997 317.364 99.8197 317.082 100.02 316.791C100.254 316.472 100.364 316.083 100.33 315.693C100.305 315.497 100.241 315.307 100.14 315.136C100.039 314.964 99.9045 314.814 99.7435 314.694C99.5824 314.574 99.3984 314.486 99.202 314.435C99.0056 314.385 98.8009 314.373 98.5997 314.4C98.203 314.453 97.8436 314.655 97.5997 314.964C97.3597 315.314 97.0897 315.644 96.8297 315.936C95.4482 314.945 94.2104 313.778 93.1497 312.466H93.2597C93.9143 312.295 94.5839 312.185 95.2597 312.136C95.6655 312.085 96.0341 311.88 96.2844 311.566C96.5348 311.252 96.6464 310.853 96.5947 310.459C96.543 310.065 96.3322 309.706 96.0087 309.463C95.6852 309.22 95.2755 309.111 94.8697 309.162L94.9297 309.22Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.9297 309.22C93.8087 309.31 92.7035 309.535 91.6397 309.891C91.3585 309.148 91.1966 308.368 91.1597 307.577C90.9297 300.541 96.1597 303.505 98.8597 301.435C99.4819 300.904 100.212 300.506 101.003 300.266C101.793 300.027 102.627 299.952 103.45 300.046C103.209 300.43 103.002 300.833 102.83 301.251C102.766 301.404 102.739 301.57 102.75 301.736C102.761 301.901 102.81 302.062 102.893 302.206C102.977 302.351 103.092 302.476 103.232 302.571C103.372 302.666 103.531 302.73 103.7 302.757C104.375 302.877 105.073 302.796 105.7 302.524C105.883 302.418 106.057 302.298 106.22 302.164C106.655 302.907 106.991 303.701 107.22 304.526C107.494 305.509 107.648 306.52 107.68 307.539C107.27 307.626 106.866 307.737 106.47 307.869C106.313 307.935 106.173 308.035 106.062 308.162C105.95 308.288 105.87 308.437 105.826 308.598C105.783 308.759 105.778 308.928 105.811 309.091C105.845 309.254 105.916 309.408 106.02 309.541C106.454 309.96 106.958 310.305 107.51 310.561C107.328 311.691 107.023 312.799 106.6 313.865H106.23C105.966 313.917 105.706 313.981 105.45 314.06C105.303 314.098 105.159 314.147 105.02 314.206C104.842 314.281 104.686 314.399 104.567 314.549C104.449 314.698 104.37 314.874 104.34 315.061C104.311 315.253 104.336 315.449 104.412 315.628C104.487 315.807 104.611 315.964 104.77 316.081C104.94 316.203 105.121 316.31 105.31 316.402C104.615 317.564 103.628 318.534 102.44 319.22C101.389 318.754 100.367 318.229 99.3797 317.646C99.5997 317.364 99.8197 317.082 100.02 316.791C100.254 316.472 100.364 316.083 100.33 315.693C100.305 315.497 100.241 315.307 100.14 315.136C100.039 314.964 99.9045 314.814 99.7435 314.694C99.5824 314.574 99.3984 314.486 99.202 314.435C99.0056 314.385 98.8009 314.373 98.5997 314.4C98.203 314.453 97.8436 314.655 97.5997 314.964C97.3597 315.314 97.0897 315.644 96.8297 315.936C95.4482 314.945 94.2104 313.778 93.1497 312.466H93.2597C93.9143 312.295 94.5839 312.185 95.2597 312.136C95.6655 312.085 96.0341 311.88 96.2844 311.566C96.5348 311.252 96.6464 310.853 96.5947 310.459C96.543 310.065 96.3322 309.706 96.0087 309.463C95.6852 309.22 95.2755 309.111 94.8697 309.162L94.9297 309.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0001 284.943C97.6208 284.516 98.2923 284.163 99.0001 283.893C98.815 283.383 98.5484 282.904 98.2101 282.474C95.1501 278.674 93.7701 282.474 91.3901 282.533C90.8297 282.521 90.273 282.624 89.7562 282.835C89.2394 283.046 88.774 283.36 88.3901 283.757C88.6904 283.856 88.9814 283.98 89.2601 284.126C89.3649 284.179 89.456 284.254 89.5262 284.346C89.5965 284.438 89.644 284.544 89.6653 284.657C89.6866 284.77 89.6809 284.885 89.6488 284.996C89.6167 285.106 89.559 285.208 89.4801 285.293C89.18 285.653 88.7705 285.911 88.3101 286.031C88.1638 286.046 88.0164 286.046 87.8701 286.031C87.9814 286.604 88.1626 287.162 88.4101 287.693C88.7135 288.325 89.0892 288.922 89.5301 289.472C89.7826 289.343 90.0431 289.229 90.3101 289.132C90.4234 289.099 90.5428 289.092 90.6592 289.111C90.7757 289.13 90.8863 289.174 90.9826 289.24C91.0789 289.307 91.1584 289.394 91.2151 289.494C91.2719 289.595 91.3043 289.707 91.3101 289.822C91.2725 290.226 91.1607 290.621 90.9801 290.988C91.5968 291.504 92.2671 291.957 92.9801 292.339L93.2001 292.212C93.3601 292.125 93.5301 292.047 93.7001 291.969C93.7957 291.925 93.8965 291.893 94.0001 291.872C94.1271 291.837 94.2611 291.832 94.3902 291.859C94.5194 291.887 94.6396 291.944 94.7401 292.028C94.8388 292.118 94.9118 292.232 94.9521 292.358C94.9924 292.484 94.9986 292.618 94.9701 292.747C94.9384 292.884 94.8915 293.018 94.8301 293.145C95.719 293.461 96.6765 293.548 97.6101 293.398C97.9514 292.706 98.2519 291.995 98.5101 291.27C98.2701 291.224 98.0301 291.166 97.7901 291.095C97.5207 291.03 97.2855 290.871 97.1301 290.648C96.9801 290.416 96.9298 290.137 96.9901 289.87C97.0169 289.738 97.0716 289.613 97.1508 289.502C97.23 289.392 97.3319 289.299 97.4501 289.229C97.6864 289.088 97.9685 289.04 98.2401 289.093L99.1001 289.297C99.3798 288.187 99.5042 287.047 99.4701 285.905H99.4001C98.9685 286.1 98.5567 286.334 98.1701 286.605C97.9341 286.75 97.6482 286.799 97.3753 286.74C97.1024 286.68 96.865 286.518 96.7151 286.289C96.5653 286.059 96.5153 285.782 96.5763 285.516C96.6372 285.251 96.8041 285.02 97.0401 284.875L97.0001 284.943Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.0001 284.943C97.6208 284.516 98.2923 284.163 99.0001 283.893C98.815 283.383 98.5484 282.904 98.2101 282.474C95.1501 278.674 93.7701 282.474 91.3901 282.533C90.8297 282.521 90.273 282.624 89.7562 282.835C89.2394 283.046 88.774 283.36 88.3901 283.757C88.6904 283.856 88.9814 283.98 89.2601 284.126C89.3649 284.179 89.456 284.254 89.5262 284.346C89.5965 284.438 89.644 284.544 89.6653 284.657C89.6866 284.77 89.6809 284.885 89.6488 284.996C89.6167 285.106 89.559 285.208 89.4801 285.293C89.18 285.653 88.7705 285.911 88.3101 286.031C88.1638 286.046 88.0164 286.046 87.8701 286.031C87.9814 286.604 88.1626 287.162 88.4101 287.693C88.7135 288.325 89.0892 288.922 89.5301 289.472C89.7826 289.343 90.0431 289.229 90.3101 289.132C90.4234 289.099 90.5428 289.092 90.6592 289.111C90.7757 289.13 90.8863 289.174 90.9826 289.24C91.0789 289.307 91.1584 289.394 91.2151 289.494C91.2719 289.595 91.3043 289.707 91.3101 289.822C91.2725 290.226 91.1607 290.621 90.9801 290.988C91.5968 291.504 92.2671 291.957 92.9801 292.339L93.2001 292.212C93.3601 292.125 93.5301 292.047 93.7001 291.969C93.7957 291.925 93.8965 291.893 94.0001 291.872C94.1271 291.837 94.2611 291.832 94.3902 291.859C94.5194 291.887 94.6396 291.944 94.7401 292.028C94.8388 292.118 94.9118 292.232 94.9521 292.358C94.9924 292.484 94.9986 292.618 94.9701 292.747C94.9384 292.884 94.8915 293.018 94.8301 293.145C95.719 293.461 96.6765 293.548 97.6101 293.398C97.9514 292.706 98.2519 291.995 98.5101 291.27C98.2701 291.224 98.0301 291.166 97.7901 291.095C97.5207 291.03 97.2855 290.871 97.1301 290.648C96.9801 290.416 96.9298 290.137 96.9901 289.87C97.0169 289.738 97.0716 289.613 97.1508 289.502C97.23 289.392 97.3319 289.299 97.4501 289.229C97.6864 289.088 97.9685 289.04 98.2401 289.093L99.1001 289.297C99.3798 288.187 99.5042 287.047 99.4701 285.905H99.4001C98.9685 286.1 98.5567 286.334 98.1701 286.605C97.9341 286.75 97.6482 286.799 97.3753 286.74C97.1024 286.68 96.865 286.518 96.7151 286.289C96.5653 286.059 96.5153 285.782 96.5763 285.516C96.6372 285.251 96.8041 285.02 97.0401 284.875L97.0001 284.943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7299 291.989C67.5199 293.417 71.5099 294.36 74.7299 294.904C74.4599 297.499 72.7299 300.123 70.2299 302.572C67.1499 300.881 62.7399 298.685 61.9299 299.19C61.1199 299.696 65.5599 302.621 68.3799 304.293C66.3663 306.009 64.2347 307.59 61.9999 309.026C60.6099 307.762 58.9999 306.664 57.9999 307.257C56.9999 307.85 57.2699 309.822 57.7599 311.552C54.4099 313.496 51.8899 314.614 51.8899 314.614C50.9136 311.583 50.165 308.488 49.6499 305.352C49.8199 305.031 49.9899 304.701 50.1399 304.38C50.6799 303.165 50.1399 302.65 49.2599 302.436C49.0253 300.22 49.0253 297.986 49.2599 295.769C53.0599 294.992 57.6799 293.563 55.9499 291.347C54.9499 290.006 52.9499 289.86 51.0099 290.191C51.2763 289.747 51.5879 289.33 51.9399 288.947C58.8599 281.541 63.6799 288.947 63.6799 288.947C67.6799 285.691 73.3399 286.575 74.5599 291.658C72.3099 291.065 67.9999 290.23 67.7299 291.989Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.7299 291.989C67.5199 293.417 71.5099 294.36 74.7299 294.904C74.4599 297.499 72.7299 300.123 70.2299 302.572C67.1499 300.881 62.7399 298.685 61.9299 299.19C61.1199 299.696 65.5599 302.621 68.3799 304.293C66.3663 306.009 64.2347 307.59 61.9999 309.026C60.6099 307.762 58.9999 306.664 57.9999 307.257C56.9999 307.85 57.2699 309.822 57.7599 311.552C54.4099 313.496 51.8899 314.614 51.8899 314.614C50.9136 311.583 50.165 308.488 49.6499 305.352C49.8199 305.031 49.9899 304.701 50.1399 304.38C50.6799 303.165 50.1399 302.65 49.2599 302.436C49.0253 300.22 49.0253 297.986 49.2599 295.769C53.0599 294.992 57.6799 293.563 55.9499 291.347C54.9499 290.006 52.9499 289.86 51.0099 290.191C51.2763 289.747 51.5879 289.33 51.9399 288.947C58.8599 281.541 63.6799 288.947 63.6799 288.947C67.6799 285.691 73.3399 286.575 74.5599 291.658C72.3099 291.065 67.9999 290.23 67.7299 291.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.401 353.352V237.088H263.991V353.352L257.051 355.976V358.037H266.061H267.331H276.331V355.976L269.401 353.352Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.46 353.352V237.088H364.05V353.352L357.12 355.976V358.037H366.12H367.39H376.4V355.976L369.46 353.352Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M276.341 355.976V358.037H257.051V355.976L263.991 353.343V237.088H269.401V353.343L276.341 355.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M376.4 355.976V358.037H357.12V355.976L364.05 353.343V237.088H369.46V353.343L376.4 355.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M263.99 237.088H269.4V248.245L263.99 247.652V237.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M369.461 237.088V259.149L364.051 258.557V237.088H369.461Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.861 130.707H247.591V244.153H385.861V130.707Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 230.159H247.44V244.163H386V230.159Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 130.707H247.44V144.712H386V130.707Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.471 230.159L251.191 244.153H247.591V239.003L254.091 230.159H261.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.431 244.153H258.041L268.331 230.159H275.711L265.431 244.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.671 244.153H272.281L282.571 230.159H289.951L279.671 244.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.911 244.153H286.521L296.811 230.159H304.191L293.911 244.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.151 244.153H300.771L311.051 230.159H318.441L308.151 244.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.391 244.153H315.011L325.291 230.159H332.681L322.391 244.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.631 244.153H329.251L339.541 230.159H346.921L336.631 244.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.881 244.153H343.491L353.781 230.159H361.161L350.881 244.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.12 244.153H357.73L368.02 230.159H375.4L365.12 244.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.86 230.159V235.309L379.36 244.153H371.98L382.26 230.159H385.86Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.471 130.707L251.191 144.712H247.591V139.551L254.091 130.707H261.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.431 144.712H258.041L268.331 130.707H275.711L265.431 144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.671 144.712H272.281L282.571 130.707H289.951L279.671 144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.911 144.712H286.521L296.811 130.707H304.191L293.911 144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.151 144.712H300.771L311.051 130.707H318.441L308.151 144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.391 144.712H315.011L325.291 130.707H332.681L322.391 144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.631 144.712H329.251L339.541 130.707H346.921L336.631 144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.881 144.712H343.491L353.781 130.707H361.161L350.881 144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.12 144.712H357.73L368.02 130.707H375.4L365.12 144.712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.86 130.707V135.868L379.36 144.712H371.98L382.26 130.707H385.86Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320.75 369.398C353.103 369.398 379.33 367.244 379.33 364.587C379.33 361.93 353.103 359.776 320.75 359.776C288.397 359.776 262.17 361.93 262.17 364.587C262.17 367.244 288.397 369.398 320.75 369.398Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.18 360.933L240.34 293.942H235.04L221.19 360.933L211.02 366.988V368.776H264.02V366.988L254.18 360.933Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.02 366.988H211.02V369.242H264.02V366.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M240.339 293.942H235.039L221.029 360.739H254.009L240.339 293.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M249.579 339.056L246.429 323.681H228.799L225.569 339.056H249.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.44 83.7856H103.71C102.549 83.7843 101.398 84.0056 100.324 84.4368C99.2507 84.868 98.275 85.5006 97.4531 86.2985C96.6311 87.0964 95.9791 88.0439 95.5342 89.0869C95.0893 90.1299 94.8604 91.2479 94.8604 92.3769V106.955C94.8604 109.236 95.7928 111.424 97.4525 113.037C99.1122 114.65 101.363 115.556 103.71 115.556H132.11L145.11 129.055L138.11 115.556H146.49C148.838 115.556 151.089 114.65 152.748 113.037C154.408 111.424 155.34 109.236 155.34 106.955V92.3769C155.34 91.2438 155.11 90.1218 154.662 89.0756C154.214 88.0295 153.557 87.0798 152.73 86.2812C151.903 85.4827 150.921 84.8511 149.842 84.4227C148.762 83.9944 147.606 83.7779 146.44 83.7856Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M146.44 83.7856H103.71C102.549 83.7843 101.398 84.0056 100.324 84.4368C99.2507 84.868 98.275 85.5006 97.4531 86.2985C96.6311 87.0964 95.9791 88.0439 95.5342 89.0869C95.0893 90.1299 94.8604 91.2479 94.8604 92.3769V106.955C94.8604 109.236 95.7928 111.424 97.4525 113.037C99.1122 114.65 101.363 115.556 103.71 115.556H132.11L145.11 129.055L138.11 115.556H146.49C148.838 115.556 151.089 114.65 152.748 113.037C154.408 111.424 155.34 109.236 155.34 106.955V92.3769C155.34 91.2438 155.11 90.1218 154.662 89.0756C154.214 88.0295 153.557 87.0798 152.73 86.2812C151.903 85.4827 150.921 84.8511 149.842 84.4227C148.762 83.9944 147.606 83.7779 146.44 83.7856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8 98.869C105.763 97.8878 106.027 96.918 106.56 96.084C107.093 95.25 107.871 94.5899 108.793 94.1882C109.715 93.7865 110.739 93.6616 111.734 93.8296C112.73 93.9976 113.651 94.4507 114.379 95.1309C115.108 95.8111 115.611 96.6873 115.823 97.6472C116.036 98.607 115.949 99.6067 115.573 100.518C115.197 101.429 114.549 102.211 113.713 102.762C112.877 103.313 111.891 103.609 110.88 103.612C110.222 103.642 109.564 103.542 108.947 103.317C108.329 103.092 107.766 102.747 107.29 102.303C106.815 101.859 106.438 101.325 106.181 100.735C105.925 100.145 105.796 99.5097 105.8 98.869V98.869ZM114.57 98.869C114.58 98.153 114.371 97.4504 113.968 96.8507C113.566 96.251 112.989 95.7813 112.311 95.5015C111.632 95.2217 110.884 95.1444 110.16 95.2796C109.437 95.4148 108.771 95.7562 108.248 96.2605C107.725 96.7647 107.368 97.4088 107.223 98.1109C107.078 98.8129 107.152 99.5409 107.434 100.202C107.716 100.864 108.195 101.428 108.809 101.824C109.423 102.22 110.144 102.43 110.88 102.426C111.366 102.439 111.85 102.357 112.302 102.183C112.753 102.009 113.164 101.748 113.509 101.416C113.854 101.083 114.126 100.686 114.309 100.248C114.491 99.8103 114.58 99.3411 114.57 98.869V98.869Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.161 99.9963C117.147 99.2708 117.355 98.5577 117.76 97.9479C118.165 97.3381 118.747 96.8592 119.433 96.5721C120.118 96.2851 120.876 96.2029 121.61 96.3362C122.344 96.4694 123.021 96.8119 123.554 97.3202C124.087 97.8284 124.452 98.4793 124.602 99.19C124.753 99.9006 124.683 100.639 124.401 101.311C124.118 101.982 123.636 102.557 123.017 102.962C122.397 103.366 121.667 103.582 120.921 103.582C120.427 103.605 119.933 103.529 119.471 103.358C119.009 103.187 118.588 102.924 118.235 102.588C117.882 102.251 117.604 101.847 117.419 101.401C117.234 100.955 117.146 100.477 117.161 99.9963ZM123.351 99.9963C123.329 99.532 123.168 99.0841 122.886 98.7083C122.605 98.3324 122.216 98.0452 121.768 97.8823C121.321 97.7194 120.833 97.688 120.367 97.792C119.901 97.896 119.477 98.1308 119.147 98.4673C118.817 98.8038 118.596 99.227 118.512 99.6845C118.427 100.142 118.483 100.613 118.672 101.04C118.861 101.467 119.175 101.831 119.575 102.086C119.974 102.341 120.442 102.476 120.921 102.475C121.252 102.482 121.582 102.422 121.888 102.299C122.195 102.175 122.471 101.991 122.7 101.758C122.929 101.525 123.105 101.247 123.217 100.944C123.329 100.641 123.374 100.318 123.351 99.9963V99.9963Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.001 99.9963C134.026 100.47 133.949 100.945 133.775 101.388C133.602 101.832 133.334 102.236 132.991 102.573C132.647 102.911 132.235 103.175 131.78 103.349C131.326 103.522 130.839 103.602 130.351 103.582C129.868 103.597 129.39 103.501 128.952 103.304C128.515 103.106 128.131 102.812 127.831 102.445V106.07H126.521V96.4879H127.771V97.5958C128.072 97.2129 128.464 96.9062 128.913 96.7015C129.362 96.4968 129.855 96.4002 130.351 96.4198C130.838 96.3989 131.325 96.4772 131.78 96.6499C132.234 96.8226 132.647 97.0858 132.99 97.4226C133.334 97.7595 133.601 98.1624 133.775 98.6056C133.949 99.0489 134.026 99.5226 134.001 99.9963V99.9963ZM132.68 99.9963C132.659 99.5324 132.498 99.0849 132.217 98.7092C131.936 98.3336 131.548 98.0463 131.101 97.8831C130.653 97.7199 130.166 97.688 129.701 97.7912C129.235 97.8944 128.81 98.1283 128.48 98.4638C128.15 98.7993 127.928 99.2216 127.842 99.6785C127.757 100.135 127.811 100.607 127.999 101.034C128.186 101.461 128.499 101.825 128.897 102.081C129.296 102.337 129.763 102.474 130.241 102.475C130.569 102.477 130.895 102.413 131.197 102.287C131.499 102.161 131.771 101.976 131.996 101.744C132.221 101.511 132.395 101.236 132.506 100.935C132.617 100.635 132.663 100.315 132.641 99.9963H132.68Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.86 102.766L135.4 101.794C136.156 102.271 137.039 102.525 137.94 102.523C139.15 102.523 139.65 102.164 139.65 101.551C139.65 99.9768 135.09 101.337 135.09 98.5385C135.09 97.2848 136.25 96.4392 138.09 96.4392C139.009 96.4226 139.916 96.6404 140.72 97.071L140.16 98.0428C139.538 97.6647 138.814 97.4722 138.08 97.4889C136.93 97.4889 136.37 97.897 136.37 98.4607C136.37 100.113 140.95 98.762 140.95 101.493C140.95 102.766 139.75 103.573 137.83 103.573C136.78 103.599 135.745 103.318 134.86 102.766V102.766Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.301 102.737C142.301 102.623 142.324 102.511 142.37 102.407C142.415 102.302 142.482 102.207 142.566 102.129C142.65 102.05 142.75 101.988 142.859 101.947C142.968 101.907 143.084 101.888 143.201 101.891C143.316 101.889 143.43 101.909 143.537 101.95C143.644 101.992 143.741 102.054 143.822 102.133C143.903 102.212 143.967 102.307 144.01 102.41C144.053 102.514 144.074 102.625 144.071 102.737C144.072 102.848 144.051 102.959 144.007 103.062C143.964 103.165 143.9 103.259 143.819 103.338C143.738 103.417 143.641 103.479 143.535 103.521C143.429 103.563 143.315 103.584 143.201 103.583C143.084 103.585 142.969 103.565 142.86 103.524C142.752 103.483 142.653 103.421 142.569 103.342C142.485 103.264 142.419 103.17 142.373 103.066C142.326 102.962 142.302 102.85 142.301 102.737V102.737ZM142.421 94.2332H144.001L143.741 100.579H142.741L142.421 94.2332Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2207 363.917L81.6407 367.513L90.7307 353.352L84.3007 349.766L75.2207 363.917Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M84.3004 349.766L90.7204 353.362L86.0303 360.661L79.6104 357.065L84.3004 349.766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5204 362.993H74.5204C74.3731 362.994 74.2306 363.044 74.1162 363.134C74.0017 363.224 73.9221 363.349 73.8904 363.489L72.4304 369.894C72.3739 370.17 72.4312 370.458 72.5901 370.694C72.749 370.93 72.9968 371.096 73.2804 371.157H73.5204C76.4304 371.108 78.5204 370.943 82.2004 370.943C84.4504 370.943 91.2004 371.167 94.3504 371.167C97.5004 371.167 97.8704 368.183 96.6004 367.911C90.8904 366.696 86.6004 364.995 84.7604 363.431C84.421 363.134 83.9764 362.977 83.5204 362.993V362.993Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 363.994C83.966 363.985 83.9356 363.966 83.9124 363.941C83.8893 363.915 83.8746 363.883 83.87 363.849C83.8637 363.816 83.868 363.783 83.8824 363.753C83.8968 363.724 83.9204 363.699 83.95 363.683C84.22 363.518 86.61 362.09 87.43 362.498C87.5218 362.541 87.5989 362.608 87.6522 362.693C87.7054 362.777 87.7324 362.875 87.73 362.974C87.7573 363.144 87.7374 363.319 87.6724 363.479C87.6074 363.64 87.4996 363.781 87.36 363.888C86.9446 364.166 86.443 364.296 85.94 364.257C85.2854 364.238 84.6349 364.15 84 363.994V363.994ZM84.51 363.751C85.3746 364.036 86.3183 363.991 87.15 363.625C87.2346 363.547 87.2994 363.452 87.3393 363.345C87.3793 363.239 87.3932 363.125 87.38 363.013C87.38 362.877 87.31 362.809 87.27 362.809C87.1946 362.79 87.1154 362.79 87.04 362.809C86.1536 362.969 85.3058 363.289 84.54 363.751H84.51Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0002 364.023C83.9741 364.007 83.953 363.983 83.9389 363.956C83.9249 363.929 83.9184 363.898 83.9202 363.868C83.9202 363.771 84.1102 361.701 84.9202 361.02C85.024 360.938 85.144 360.876 85.2728 360.839C85.4017 360.803 85.5368 360.791 85.6702 360.807C85.8024 360.806 85.9306 360.851 86.0327 360.933C86.1349 361.014 86.2047 361.128 86.2302 361.254C86.3802 362.012 84.9002 363.596 84.1402 364.004H84.0602L84.0002 364.023ZM85.1902 361.224C84.6699 361.873 84.3632 362.659 84.3102 363.479C85.0802 362.916 86.0202 361.72 85.9202 361.254C85.9202 361.205 85.9202 361.079 85.6702 361.079H85.5802C85.43 361.078 85.2846 361.13 85.1702 361.224H85.1902Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.79 365.588L186.42 364.733L184.22 348.794L176.58 349.65L178.79 365.588Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M176.58 349.65L184.22 348.794L185.35 357.016L177.72 357.872L176.58 349.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.591 362.993H177.591C177.443 362.993 177.3 363.042 177.185 363.132C177.07 363.222 176.991 363.348 176.961 363.489L175.501 369.894C175.47 370.03 175.467 370.171 175.493 370.309C175.519 370.447 175.572 370.578 175.65 370.695C175.728 370.813 175.829 370.914 175.948 370.993C176.067 371.073 176.2 371.128 176.341 371.157H176.581C179.491 371.108 181.581 370.943 185.271 370.943C187.521 370.943 194.271 371.167 197.421 371.167C200.571 371.167 200.931 368.183 199.661 367.911C193.951 366.696 189.661 364.995 187.831 363.431C187.489 363.138 187.046 362.981 186.591 362.993V362.993Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.09 363.994C187.056 363.985 187.026 363.966 187.003 363.941C186.98 363.915 186.965 363.883 186.96 363.849C186.953 363.815 186.958 363.78 186.974 363.75C186.991 363.72 187.018 363.696 187.05 363.683C187.31 363.518 189.7 362.09 190.52 362.498C190.613 362.54 190.691 362.607 190.744 362.692C190.797 362.777 190.824 362.875 190.82 362.974C190.849 363.144 190.83 363.317 190.767 363.478C190.704 363.638 190.598 363.78 190.46 363.888C190.042 364.167 189.537 364.298 189.03 364.257C188.376 364.237 187.725 364.149 187.09 363.994V363.994ZM187.6 363.751C188.465 364.036 189.409 363.991 190.24 363.625C190.328 363.549 190.396 363.454 190.437 363.347C190.479 363.241 190.494 363.126 190.48 363.013C190.48 362.877 190.41 362.809 190.36 362.809C190.288 362.79 190.212 362.79 190.14 362.809C189.24 362.964 188.378 363.284 187.6 363.751V363.751Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.05 364.024C187.022 364.009 186.998 363.986 186.982 363.959C186.966 363.931 186.958 363.9 186.96 363.868C186.96 363.771 187.15 361.701 187.96 361.02C188.061 360.936 188.179 360.873 188.307 360.836C188.434 360.799 188.568 360.789 188.7 360.807C188.834 360.806 188.963 360.85 189.067 360.932C189.171 361.013 189.243 361.127 189.27 361.254C189.42 362.012 187.94 363.596 187.18 364.004H187.09L187.05 364.024ZM188.23 361.225C187.713 361.874 187.41 362.66 187.36 363.479C188.12 362.916 189.06 361.72 188.97 361.254C188.97 361.205 188.97 361.079 188.71 361.079H188.63C188.484 361.081 188.342 361.133 188.23 361.225V361.225Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.32 353.731L173.5 350.758C173.5 350.758 164.21 285.37 142.36 255.738C139.801 252.131 136.704 248.915 133.17 246.194C131.81 262.619 130.17 280.093 128.82 289.394C125.4 312.281 92.2699 356.375 92.2699 356.375L80.6699 351.642C80.6699 351.642 107.3 303.729 108.58 281.23C109.98 256.807 110.58 213.967 110.64 208.952H150C153.68 228.769 181.78 274.116 186.32 353.731Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.32 353.731L173.5 350.758C173.5 350.758 164.21 285.37 142.36 255.738C139.801 252.131 136.704 248.915 133.17 246.194C131.81 262.619 130.17 280.093 128.82 289.394C125.4 312.281 92.2699 356.375 92.2699 356.375L80.6699 351.642C80.6699 351.642 107.3 303.729 108.58 281.23C109.98 256.807 110.58 213.967 110.64 208.952H150C153.68 228.769 181.78 274.116 186.32 353.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64 166.783C173.58 178.504 173.1 190.215 172.48 201.916L172.39 200.944C173.24 206.183 173.99 211.44 174.7 216.698C175.41 221.956 176 227.253 176.45 232.559L171.28 233.531C168.09 223.365 165.45 213.054 162.98 202.713C162.57 190.691 162.71 178.63 162.98 166.599L173.6 166.783H173.64Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.87 163.731C176.1 165.675 172.34 186.182 173.12 201.566C173.261 203.11 173.512 204.643 173.87 206.153L163 207.339C162.325 204.882 161.81 202.386 161.46 199.865C160.93 192.693 161.46 172.41 161.46 172.41L172.87 163.731Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M173.12 201.566C173.261 203.11 173.512 204.643 173.87 206.153L163 207.339C162.33 204.882 161.819 202.385 161.47 199.866C161.33 198.019 161.26 195.298 161.24 192.285C161.24 187.737 161.24 182.508 161.34 178.562C161.4 174.957 161.47 172.42 161.47 172.42L172.88 163.741C176.09 165.685 172.34 186.182 173.12 201.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.29 231.169L178.36 241.043L169.3 241.403C169.3 241.403 166.86 234.697 171.43 230.858L176.29 231.169Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.271 247.924L169.451 246.622L169.301 241.403L178.361 241.043L176.271 247.924Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.051 205.57L173.871 203.753L174.201 206.921L162.841 208.078L162.051 205.57Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M162.051 205.57L173.871 203.753L174.201 206.921L162.841 208.078L162.051 205.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.23 192.285C161.23 187.737 161.23 182.508 161.33 178.562C162.164 176.718 163.31 175.023 164.72 173.547C165.823 179.998 164.59 186.62 161.23 192.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.981 355.899L171.511 353.518L172.021 349.086L189.151 351.273L187.981 355.899Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2104 359.135L78.3604 353.401L80.1303 349.086L95.6504 354.762L93.2104 359.135Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M142.36 255.719C139.801 252.112 136.704 248.895 133.17 246.175L134.26 232.569C134.26 232.569 141.07 243.434 142.36 255.719Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.871 163.731C158.051 187.63 151.471 216.912 151.471 216.912L144.231 228.992L139.231 215.386L138.001 215.211L136.201 214.949L134.361 214.677L130.581 214.094L128.671 213.783C128.031 213.685 127.401 213.579 126.761 213.462L124.871 213.131L123.001 212.791C121.291 212.471 119.621 212.14 118.001 211.819L117.161 211.635C116.001 211.372 114.891 211.11 113.861 210.838C112.831 210.566 111.861 210.294 111.051 210.021L110.431 209.817C111.841 200.094 114.225 190.527 117.551 181.254C118.051 179.864 118.551 178.533 119.081 177.24C121.013 172.382 123.285 167.657 125.881 163.1L126.041 162.818C130.641 154.81 139.961 151.321 145.561 152.701C150.854 154.201 156.056 155.992 161.141 158.065C165.171 159.709 169.089 161.601 172.871 163.731Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M172.871 163.731C158.051 187.63 151.471 216.912 151.471 216.912L144.231 228.992L139.231 215.386L138.001 215.211L136.201 214.949L134.361 214.677L130.581 214.094L128.671 213.783C128.031 213.685 127.401 213.579 126.761 213.462L124.871 213.131L123.001 212.791C121.291 212.471 119.621 212.14 118.001 211.819L117.161 211.635C116.001 211.372 114.891 211.11 113.861 210.838C112.831 210.566 111.861 210.303 111.051 210.021L110.431 209.817C111.841 200.094 114.225 190.527 117.551 181.254C118.051 179.864 118.551 178.533 119.081 177.24C121.013 172.382 123.285 167.657 125.881 163.1L126.041 162.818C130.641 154.81 139.961 151.321 145.561 152.701C150.854 154.201 156.056 155.992 161.141 158.065C165.171 159.709 169.089 161.601 172.871 163.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.091 180.428C149.091 180.428 148.671 182.605 148.161 185.676C147.506 189.07 146.501 192.391 145.161 195.589C144.361 197.173 141.071 203.491 141.701 206.28C142.331 209.069 139.241 215.318 139.241 215.318L138.011 215.143C138.771 211.693 141.321 200.565 142.701 199.234C144.331 197.698 146.871 190.905 146.341 188.349C145.811 185.793 149.091 180.428 149.091 180.428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.26 231.169L140.34 241.043L131.28 241.403C131.28 241.403 128.83 234.697 133.4 230.858L138.26 231.169Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.25 247.924L131.43 246.622L131.28 241.403L140.34 241.043L138.25 247.924Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 153.128C145 155.879 153 165.763 153 165.763L160 157.988C159.475 157.546 159.041 157.012 158.72 156.413C158.373 155.786 158.216 155.077 158.265 154.367C158.315 153.657 158.569 152.975 159 152.399C159.367 151.934 159.798 151.519 160.28 151.165C160.358 151.112 160.431 151.054 160.5 150.99L157 138.239C154.82 143.167 149.17 152.322 144 153.128Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.76 156.442C158.413 155.816 158.255 155.106 158.305 154.396C158.354 153.686 158.609 153.004 159.04 152.429C159.407 151.963 159.838 151.548 160.32 151.194L155.09 142.292C151.8 149.358 156 154.295 158.76 156.442Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66 127.491C171.66 127.491 174.5 137.132 169.66 141.592C164.82 146.053 162.36 127.734 162.36 127.734L171.66 127.491Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.66 127.491C171.66 127.491 174.5 137.132 169.66 141.592C164.82 146.053 162.36 127.734 162.36 127.734L171.66 127.491Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.081 151.36C156.419 152.839 158.221 153.85 160.208 154.237C162.196 154.623 164.26 154.363 166.081 153.498C168.463 152.427 170.335 150.511 171.311 148.143C171.448 147.825 171.568 147.501 171.671 147.171C173.521 140.825 172.541 125.877 165.901 127.092C160.461 128.064 154.901 126.956 152.591 131.835C151.915 133.224 151.596 134.751 151.661 136.286C151.781 143.381 151.521 147.579 155.081 151.36Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.29 139.163C167.922 140.965 168.811 142.673 169.93 144.236C169.508 144.504 169.031 144.679 168.531 144.75C168.032 144.82 167.523 144.784 167.04 144.644L167.29 139.163Z",
    fill: "#ED893E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.87 134.089C164.807 134.077 164.742 134.08 164.681 134.099C164.62 134.118 164.564 134.151 164.52 134.196C164.238 134.526 163.88 134.785 163.475 134.954C163.07 135.123 162.63 135.197 162.19 135.168C162.099 135.157 162.006 135.182 161.933 135.236C161.86 135.291 161.813 135.371 161.8 135.46C161.793 135.503 161.795 135.548 161.806 135.59C161.817 135.633 161.836 135.673 161.863 135.709C161.89 135.744 161.924 135.774 161.963 135.796C162.002 135.818 162.045 135.833 162.09 135.839V135.839C162.644 135.885 163.2 135.802 163.714 135.595C164.227 135.389 164.682 135.066 165.04 134.653C165.104 134.59 165.14 134.504 165.14 134.415C165.14 134.326 165.104 134.241 165.04 134.177V134.177L164.87 134.089Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.291 133.672C169.223 133.647 169.148 133.647 169.081 133.672C169.003 133.72 168.947 133.796 168.927 133.883C168.906 133.97 168.922 134.062 168.971 134.138V134.138C169.26 134.601 169.661 134.99 170.137 135.27C170.614 135.551 171.154 135.716 171.711 135.751C171.756 135.753 171.802 135.745 171.845 135.729C171.888 135.713 171.928 135.689 171.961 135.659C171.994 135.628 172.021 135.591 172.04 135.55C172.059 135.51 172.069 135.466 172.071 135.421C172.068 135.331 172.031 135.244 171.966 135.18C171.901 135.115 171.813 135.076 171.721 135.071V135.071C171.282 135.033 170.859 134.895 170.486 134.669C170.113 134.443 169.799 134.134 169.571 133.769C169.534 133.733 169.491 133.706 169.442 133.689C169.394 133.672 169.342 133.666 169.291 133.672V133.672Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 141.213C152.3 141.408 152.26 144.45 153 147.21L151.76 147.55C150.373 145.636 149.356 143.492 148.76 141.223C147.19 135.45 146.97 131.708 147.54 128.822L157.39 127.588L157.8 130.727C157.267 130.985 156.852 131.426 156.632 131.964C156.412 132.502 156.405 133.099 156.61 133.642C157.68 136.276 156.16 140.387 154.09 142.039C154.11 142.078 154 140.893 153 141.213Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153 141.213C152.3 141.408 152.26 144.45 153 147.21L151.76 147.55C150.373 145.636 149.356 143.492 148.76 141.223C147.19 135.45 146.97 131.708 147.54 128.822L157.39 127.588L157.8 130.727C157.267 130.985 156.852 131.426 156.632 131.964C156.412 132.502 156.405 133.099 156.61 133.642C157.68 136.276 156.16 140.387 154.09 142.039C154.11 142.078 154 140.893 153 141.213Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21 141.971C148.956 143.614 150.34 144.903 152.06 145.558C154.35 146.403 155.72 144.469 155.27 142.253C154.86 140.309 153.19 137.394 150.8 137.54C150.279 137.568 149.774 137.723 149.331 137.99C148.887 138.258 148.52 138.629 148.263 139.07C148.005 139.51 147.865 140.007 147.856 140.514C147.847 141.021 147.969 141.522 148.21 141.971V141.971Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.51 125.955C149.51 125.955 148.32 123.953 150.92 121.572C153.52 119.191 164.42 118.219 167.68 120.182C170.94 122.145 173.61 120.697 173.44 119.405C173.76 119.788 173.949 120.259 173.981 120.752C174.014 121.245 173.888 121.735 173.62 122.155C173.62 122.155 175.71 122.048 176.73 125.071C176.348 125.007 175.955 125.027 175.582 125.13C175.208 125.232 174.862 125.415 174.57 125.663C174.951 126.042 175.229 126.507 175.379 127.016C175.529 127.525 175.547 128.062 175.43 128.579C174.793 127.948 173.954 127.547 173.05 127.442C173.324 128.193 173.734 128.891 174.26 129.502C174.26 129.502 169.94 129.969 167.7 128.375C168.138 129.098 168.724 129.726 169.42 130.221C169.42 130.221 162.42 131.485 160.08 128.783C159.726 129.256 159.482 129.798 159.363 130.372C159.243 130.945 159.253 131.537 159.39 132.107C158.8 132.124 158.213 132.02 157.667 131.803C157.121 131.585 156.628 131.258 156.22 130.843C154.526 132.197 152.461 133.038 150.28 133.263C150.663 132.856 150.998 132.41 151.28 131.932C151.28 131.932 147.68 133.983 145.28 132.428C145.594 131.929 145.798 131.373 145.88 130.795L144.94 131.252C144.94 131.252 144.9 126.149 149.51 125.955Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.34 141.349C162.118 141.413 161.89 141.458 161.66 141.485C161.614 141.488 161.568 141.474 161.533 141.445C161.498 141.416 161.475 141.375 161.47 141.33C161.467 141.308 161.469 141.286 161.475 141.265C161.481 141.244 161.491 141.224 161.505 141.207C161.519 141.19 161.537 141.176 161.556 141.165C161.576 141.154 161.598 141.148 161.62 141.145C162.199 141.144 162.763 140.959 163.224 140.619C163.686 140.278 164.022 139.802 164.18 139.26C164.182 139.237 164.19 139.215 164.201 139.195C164.213 139.175 164.228 139.158 164.247 139.144C164.266 139.131 164.287 139.121 164.31 139.116C164.333 139.11 164.357 139.11 164.38 139.114C164.403 139.118 164.424 139.125 164.443 139.137C164.463 139.149 164.479 139.164 164.492 139.182C164.505 139.201 164.515 139.221 164.519 139.243C164.524 139.264 164.524 139.287 164.52 139.308C164.386 139.811 164.112 140.268 163.727 140.628C163.342 140.989 162.862 141.238 162.34 141.349Z",
    fill: "#ED893E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.001 141.291C169.741 141.136 169.171 139.503 169.141 139.435C169.133 139.414 169.13 139.391 169.131 139.369C169.133 139.347 169.139 139.325 169.149 139.305C169.159 139.285 169.173 139.267 169.191 139.253C169.209 139.238 169.229 139.228 169.251 139.221C169.296 139.208 169.345 139.212 169.387 139.231C169.43 139.251 169.463 139.285 169.481 139.328C169.481 139.328 170.001 140.825 171.041 140.951C171.085 140.958 171.125 140.981 171.153 141.015C171.18 141.049 171.194 141.092 171.191 141.136C171.19 141.158 171.184 141.18 171.173 141.201C171.163 141.221 171.148 141.239 171.131 141.253C171.113 141.268 171.092 141.279 171.07 141.285C171.047 141.292 171.024 141.294 171.001 141.291Z",
    fill: "#ED893E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.701 138.686C162.631 139.26 162.961 139.746 163.361 139.765C163.761 139.785 164.081 139.318 164.111 138.745C164.141 138.171 163.831 137.676 163.451 137.666C163.071 137.656 162.721 138.103 162.701 138.686Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.44 138.949C169.38 139.522 169.72 140.008 170.11 140.028C170.5 140.047 170.83 139.581 170.86 138.997C170.89 138.414 170.58 137.938 170.19 137.928C169.8 137.919 169.47 138.405 169.44 138.949Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.07 138.716C162.917 138.75 163.761 138.587 164.53 138.239C165.25 137.715 163.92 137.199 163.27 137.199C162.62 137.199 161.63 138.21 162.07 138.716Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.111 138.599C169.9 138.894 170.751 138.998 171.591 138.9C172.451 138.628 171.361 137.734 170.741 137.53C170.121 137.326 168.861 137.977 169.111 138.599Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.581 149.183C167.581 149.183 166.701 149.532 165.581 149.892C163.581 150.543 160.691 151.224 160.521 150.038C160.494 149.877 160.503 149.713 160.546 149.555C160.589 149.398 160.666 149.251 160.771 149.124C161.631 147.978 164.501 147.56 166.401 147.365C166.441 147.682 166.532 147.99 166.671 148.279C166.886 148.653 167.2 148.965 167.581 149.183V149.183Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.57 149.892C163.57 150.543 160.68 151.224 160.51 150.038C160.484 149.877 160.492 149.713 160.535 149.555C160.578 149.398 160.655 149.251 160.76 149.124C162.46 149.008 164.77 149.027 165.57 149.892Z",
    fill: "#A02724"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.34 137.199C158.34 137.199 159.34 139.765 158.34 139.765C157.34 139.765 158.34 137.199 158.34 137.199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.641 139.415C156.641 139.415 157.641 141.981 156.641 141.981C155.641 141.981 156.641 139.415 156.641 139.415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2 131.174C170.2 131.174 171.79 133.458 170.78 133.672C169.77 133.885 170.2 131.174 170.2 131.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.241 143.497C171.241 143.497 172.161 146.112 171.121 146.063C170.081 146.014 171.241 143.497 171.241 143.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65 151.204C142.65 151.204 147.65 165.782 150.72 171.322L151.38 170.641C151.38 170.641 145.84 155.305 144.99 151.204H142.65Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.381 158.279C158.14 162.875 156.768 167.348 154.381 171.322V172.41C154.381 172.41 158.381 169.145 159.561 159.436L158.381 158.279Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.21 171.02L151.21 169.32C153.01 171.555 154.54 170.35 154.54 170.35L155.2 171.711L153.46 176.385H151.66L150.21 171.02Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.351 174.043C153.351 174.043 152.671 189.807 153.351 198.942C153.781 204.773 154.241 215.279 153.941 218.069L151.231 220.09L149.101 216.912C149.101 216.912 150.781 212.587 149.991 201.634C149.201 190.681 152.091 174.422 152.091 174.422L153.351 174.043Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.28 152.079L144.68 149.299L152.05 155.947L152.4 164.577L157.66 157.57L160.88 155.976L163.21 159.776L160.27 164.344L158.38 161.982L152.06 167.201L147.4 159.999L144.27 161.652L139.28 152.079Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M139.28 152.079L144.68 149.299L152.05 155.947L152.4 164.577L157.66 157.57L160.88 155.976L163.21 159.776L160.27 164.344L158.38 161.982L152.06 167.201L147.4 159.999L144.27 161.652L139.28 152.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.061 167.201L157.831 160.019L160.271 164.344L158.381 161.982L152.061 167.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.061 167.201L149.43 157.92L144.271 161.652L147.4 159.999L152.061 167.201Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M135.84 208.923L126.64 209.895C126.64 209.895 116.8 195.385 117.56 181.196C118.06 179.806 118.56 178.475 119.09 177.182C121.023 172.323 123.295 167.599 125.89 163.041C126.613 162.381 127.397 161.786 128.23 161.263L137.74 175.044C137.74 175.044 138.35 197.504 135.84 208.923Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.611 166.783C135.551 178.504 135.081 190.215 134.451 201.916L134.371 200.944C135.211 206.179 135.977 211.431 136.671 216.698C137.361 221.975 137.981 227.253 138.421 232.559L133.261 233.531C130.061 223.365 127.421 213.054 124.961 202.713C124.551 190.691 124.691 178.63 124.961 166.599L135.571 166.783H135.611Z",
    fill: "#FFB573"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.261 159.018C136.401 161.195 137.961 169.291 137.961 169.291C137.961 169.291 135.351 200.283 135.481 201.566C135.611 202.849 135.841 205.289 135.841 205.289L124.841 207.339C124.841 207.339 123.921 201.566 123.391 189.778C122.861 177.989 123.391 168.163 125.891 163.819C128.391 159.475 131.261 159.018 131.261 159.018Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M131.261 159.018C136.401 161.195 137.961 169.291 137.961 169.291C137.961 169.291 135.351 200.283 135.481 201.566C135.611 202.849 135.841 205.289 135.841 205.289L124.841 207.339C124.841 207.339 123.921 201.566 123.391 189.778C122.861 177.989 123.391 168.163 125.891 163.819C128.391 159.475 131.261 159.018 131.261 159.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.16 205.541L136.67 203.364L135.84 206.698L124.67 208.933L123.16 205.541Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M123.16 205.541L136.67 203.364L135.84 206.698L124.67 208.933L123.16 205.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.331 253.853L194.141 284.729C194.083 285.231 193.826 285.691 193.424 286.012C193.023 286.334 192.509 286.49 191.991 286.449L150.911 284.253C150.398 284.228 149.914 284.012 149.561 283.65C149.207 283.288 149.01 282.808 149.011 282.309L151.201 251.442C151.259 250.94 151.516 250.48 151.917 250.159C152.318 249.838 152.833 249.681 153.351 249.722L194.441 251.919C194.696 251.925 194.947 251.98 195.179 252.081C195.412 252.181 195.623 252.325 195.798 252.505C195.974 252.685 196.111 252.896 196.202 253.127C196.294 253.359 196.337 253.605 196.331 253.853V253.853Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 280.482L193.47 277.265C193.47 277.265 202.82 294.759 208.31 299.521L187.8 306.888C187.8 306.888 178.09 295.556 175 280.482Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M175 280.482L193.47 277.265C193.47 277.265 202.82 294.759 208.31 299.521L187.8 306.888C187.8 306.888 178.09 295.556 175 280.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.53 263.649C177.99 265.661 188.28 281.716 188.28 281.716L209.84 270.151C209.84 270.151 198.84 260.121 195.4 258.868C191.96 257.614 174.53 263.649 174.53 263.649Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M174.23 263.649C177.75 265.661 188.23 281.716 188.23 281.716L210.13 270.151C210.13 270.151 199 260.092 195.45 258.838C191.9 257.585 174.23 263.649 174.23 263.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.221 258.255C161.221 258.255 165.281 267.371 166.221 275.749L194.581 270.89C194.581 270.89 190.381 260.102 188.581 258.255C186.781 256.409 161.221 258.255 161.221 258.255Z",
    fill: "#023475"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M161.221 258.255C161.221 258.255 165.281 267.371 166.221 275.749L194.581 270.89C194.581 270.89 190.381 260.102 188.581 258.255C186.781 256.409 161.221 258.255 161.221 258.255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.39 252.327C182.29 247.594 176.39 243.58 171.74 242.871C168.36 242.375 165.58 248.818 164.74 251.336L163.57 250.995C163.7 250.587 166.77 240.956 171.87 241.695C176.97 242.433 183.31 246.797 184.53 252.065L183.39 252.327Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.751 249.8C155.285 249.861 155.788 250.08 156.19 250.428C156.593 250.776 156.876 251.235 157.001 251.744L159.751 265.729C159.861 266.141 160.102 266.51 160.439 266.782C160.777 267.054 161.193 267.216 161.631 267.245L198.631 269.189C198.816 269.221 199.007 269.209 199.187 269.153C199.367 269.097 199.529 268.999 199.661 268.868C199.792 268.736 199.888 268.575 199.941 268.399C199.993 268.223 200 268.037 199.961 267.857L197.201 253.824C197.061 253.309 196.759 252.85 196.338 252.511C195.917 252.171 195.397 251.967 194.851 251.928L153.801 249.742L154.751 249.8Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.751 249.8C155.285 249.861 155.788 250.08 156.19 250.428C156.593 250.776 156.876 251.235 157.001 251.744L159.751 265.729C159.861 266.141 160.102 266.51 160.439 266.782C160.777 267.054 161.193 267.216 161.631 267.245L198.631 269.189C198.816 269.221 199.007 269.209 199.187 269.153C199.367 269.097 199.529 268.999 199.661 268.868C199.792 268.736 199.888 268.575 199.941 268.399C199.993 268.223 200 268.037 199.961 267.857L197.201 253.824C197.061 253.309 196.759 252.85 196.338 252.511C195.917 252.171 195.397 251.967 194.851 251.928L153.801 249.742L154.751 249.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.461 272.007H184.411L181.661 271.852C181.415 271.824 181.183 271.727 180.994 271.571C180.805 271.415 180.669 271.208 180.601 270.977L180.151 269.286C180.115 269.172 180.107 269.052 180.13 268.935C180.153 268.818 180.205 268.708 180.281 268.615C180.353 268.53 180.445 268.465 180.55 268.424C180.655 268.383 180.769 268.369 180.881 268.382L183.631 268.538C183.876 268.563 184.108 268.659 184.297 268.813C184.485 268.967 184.623 269.172 184.691 269.403L185.141 271.103C185.177 271.215 185.184 271.334 185.162 271.45C185.139 271.565 185.087 271.673 185.011 271.764C184.944 271.843 184.86 271.905 184.765 271.947C184.669 271.989 184.566 272.01 184.461 272.007V272.007ZM184.461 271.56C184.501 271.566 184.542 271.561 184.581 271.548C184.619 271.534 184.654 271.512 184.681 271.482C184.702 271.44 184.713 271.393 184.713 271.346C184.713 271.299 184.702 271.253 184.681 271.21L184.231 269.519C184.188 269.377 184.104 269.25 183.989 269.154C183.873 269.057 183.732 268.995 183.581 268.975L180.831 268.819C180.791 268.816 180.75 268.821 180.712 268.835C180.674 268.848 180.64 268.87 180.611 268.897C180.59 268.94 180.58 268.986 180.58 269.033C180.58 269.08 180.59 269.127 180.611 269.169L181.071 270.87C181.111 271.011 181.194 271.136 181.308 271.232C181.421 271.327 181.562 271.387 181.711 271.405L184.461 271.56Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.461 272.007H184.411L181.661 271.852C181.415 271.824 181.183 271.727 180.994 271.571C180.805 271.415 180.669 271.208 180.601 270.977L180.151 269.286C180.115 269.172 180.107 269.052 180.13 268.935C180.153 268.818 180.205 268.708 180.281 268.615C180.353 268.53 180.445 268.465 180.55 268.424C180.655 268.383 180.769 268.369 180.881 268.382L183.631 268.538C183.876 268.563 184.108 268.659 184.297 268.813C184.485 268.967 184.623 269.172 184.691 269.403L185.141 271.103C185.177 271.215 185.184 271.334 185.162 271.45C185.139 271.565 185.087 271.673 185.011 271.764C184.944 271.843 184.86 271.905 184.765 271.947C184.669 271.989 184.566 272.01 184.461 272.007V272.007ZM184.461 271.56C184.501 271.566 184.542 271.561 184.581 271.548C184.619 271.534 184.654 271.512 184.681 271.482C184.702 271.44 184.713 271.393 184.713 271.346C184.713 271.299 184.702 271.253 184.681 271.21L184.231 269.519C184.188 269.377 184.104 269.25 183.989 269.154C183.873 269.057 183.732 268.995 183.581 268.975L180.831 268.819C180.791 268.816 180.75 268.821 180.712 268.835C180.674 268.848 180.64 268.87 180.611 268.897C180.59 268.94 180.58 268.986 180.58 269.033C180.58 269.08 180.59 269.127 180.611 269.169L181.071 270.87C181.111 271.011 181.194 271.136 181.308 271.232C181.421 271.327 181.562 271.387 181.711 271.405L184.461 271.56Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.759 167.427V181.245H285.235L279.224 172.548H279.123V181.245H276.201V167.427H278.765L284.729 176.118H284.851V167.427H287.759ZM302.871 174.336C302.871 175.843 302.585 177.125 302.014 178.182C301.447 179.239 300.674 180.047 299.693 180.605C298.717 181.158 297.619 181.434 296.4 181.434C295.172 181.434 294.07 181.156 293.094 180.598C292.118 180.04 291.347 179.233 290.78 178.176C290.213 177.118 289.93 175.839 289.93 174.336C289.93 172.83 290.213 171.548 290.78 170.491C291.347 169.433 292.118 168.628 293.094 168.075C294.07 167.517 295.172 167.238 296.4 167.238C297.619 167.238 298.717 167.517 299.693 168.075C300.674 168.628 301.447 169.433 302.014 170.491C302.585 171.548 302.871 172.83 302.871 174.336ZM299.909 174.336C299.909 173.36 299.763 172.537 299.47 171.867C299.182 171.197 298.775 170.688 298.249 170.342C297.723 169.996 297.107 169.823 296.4 169.823C295.694 169.823 295.078 169.996 294.552 170.342C294.025 170.688 293.616 171.197 293.324 171.867C293.036 172.537 292.892 173.36 292.892 174.336C292.892 175.312 293.036 176.136 293.324 176.806C293.616 177.476 294.025 177.984 294.552 178.331C295.078 178.677 295.694 178.85 296.4 178.85C297.107 178.85 297.723 178.677 298.249 178.331C298.775 177.984 299.182 177.476 299.47 176.806C299.763 176.136 299.909 175.312 299.909 174.336ZM281.099 204.245H276.201V190.427H281.14C282.53 190.427 283.726 190.704 284.729 191.257C285.732 191.806 286.504 192.595 287.044 193.625C287.588 194.656 287.86 195.888 287.86 197.323C287.86 198.762 287.588 199.999 287.044 201.034C286.504 202.068 285.728 202.862 284.716 203.416C283.708 203.969 282.503 204.245 281.099 204.245ZM279.123 201.742H280.978C281.842 201.742 282.568 201.589 283.157 201.283C283.751 200.973 284.196 200.494 284.493 199.846C284.795 199.194 284.945 198.353 284.945 197.323C284.945 196.302 284.795 195.467 284.493 194.82C284.196 194.172 283.753 193.695 283.164 193.389C282.575 193.083 281.848 192.93 280.985 192.93H279.123V201.742ZM291.627 204.245H288.496L293.266 190.427H297.031L301.795 204.245H298.664L295.203 193.585H295.095L291.627 204.245ZM291.431 198.814H298.826V201.095H291.431V198.814ZM301.243 192.836V190.427H312.592V192.836H308.361V204.245H305.474V192.836H301.243ZM315.154 204.245H312.023L316.794 190.427H320.559L325.322 204.245H322.191L318.73 193.585H318.622L315.154 204.245ZM314.958 198.814H322.353V201.095H314.958V198.814ZM334.763 190.427L334.5 200.103H332.03L331.76 190.427H334.763ZM333.265 204.421C332.82 204.421 332.437 204.263 332.118 203.949C331.799 203.629 331.641 203.247 331.646 202.802C331.641 202.361 331.799 201.983 332.118 201.668C332.437 201.353 332.82 201.196 333.265 201.196C333.692 201.196 334.068 201.353 334.392 201.668C334.716 201.983 334.88 202.361 334.884 202.802C334.88 203.098 334.801 203.371 334.648 203.618C334.5 203.861 334.304 204.057 334.061 204.205C333.818 204.349 333.553 204.421 333.265 204.421ZM340.923 190.427L340.66 200.103H338.191L337.921 190.427H340.923ZM339.425 204.421C338.98 204.421 338.598 204.263 338.278 203.949C337.959 203.629 337.801 203.247 337.806 202.802C337.801 202.361 337.959 201.983 338.278 201.668C338.598 201.353 338.98 201.196 339.425 201.196C339.853 201.196 340.228 201.353 340.552 201.668C340.876 201.983 341.04 202.361 341.045 202.802C341.04 203.098 340.961 203.371 340.808 203.618C340.66 203.861 340.464 204.057 340.221 204.205C339.979 204.349 339.713 204.421 339.425 204.421ZM347.083 190.427L346.82 200.103H344.351L344.081 190.427H347.083ZM345.585 204.421C345.14 204.421 344.758 204.263 344.438 203.949C344.119 203.629 343.962 203.247 343.966 202.802C343.962 202.361 344.119 201.983 344.438 201.668C344.758 201.353 345.14 201.196 345.585 201.196C346.013 201.196 346.388 201.353 346.712 201.668C347.036 201.983 347.2 202.361 347.205 202.802C347.2 203.098 347.122 203.371 346.969 203.618C346.82 203.861 346.624 204.057 346.382 204.205C346.139 204.349 345.873 204.421 345.585 204.421Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1011_1524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 442,
    height: 375,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.b4ddcbea763fb92ac56ab81fe2eb57d3.svg";
export { ForwardRef as ReactComponent };